import React, { useEffect, useState } from "react";
import $ from "jquery";
import "./ExportMenu.css";
import "./HeaderNavBar.css";
import Spinner from "../Spinner/Spinner";
import { withRouter } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { handleException } from "../../app/util/util";
import loaderColors1 from "../Spinner/loaderColors1.gif";
import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
let firstTimeOutline = false,
  firstTimeBrief = false,
  firstTimeNotes = false,
  noPrintSectionList = [],
  resultSet = [],
  relatedHighLightTags = null,
  relatedNotesSpanTag = null,
  relatedBriefTags = null,
  relatedBriefSpanTag = null,
  printHighlightChecked = true,
  printNoteChecked = true,
  sectionList = [];
function ExportMenu(props) {
  const { chapterId } = props.bookVO;
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [loading, setLoading] = useState(false);
  const [prevPrint, setPrevPrint] = useState("0");
  const [exportNotes, setExportNotes] = useState([]);
  const [printError, setPrintError] = useState(false);
  const [checkedItems, setCheckedItems] = useState({});
  const [sectionVOList, setSectionVOList] = useState();
  const [noteChecked, setNoteChecked] = useState(true);
  const [printContent, setPrintContent] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [fontSizePrint, setFontSizePrint] = useState("");
  const [pCaseNavTitle, setPCaseNavTitle] = useState("");
  const [pCaseSectionId, setPCaseSectionId] = useState("");
  const [currSelection, setCurrSelection] = useState("0.00");
  const [selectableShow, setSelectableShow] = useState(true);
  const [currentNoteContent, setNotesContent] = useState("");
  const [outlineLoading, setOutlineLoading] = useState(false);
  const [notepadLoading, setNotepadLoading] = useState(false);
  const [printAllowance, setPrintAllowance] = useState("0.00");
  const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
  const [currentNoteId, setCurrentNoteId] = useState(undefined);
  const [highLightChecked, setHighLightChecked] = useState(true);
  const [isBriefModalOpen, setIsBriefModalOpen] = useState(false);
  const [printPageLoading, setPrintPageLoading] = useState(false);
  const [casebriefLoading, setCasebriefLoading] = useState(false);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
  const [totalNumberOfPages, setTotalNumberOfPages] = useState("");
  const [sectionPrintVOList, setSectionPrintVOList] = useState([]);
  const [isOutlineModalOpen, setIsOutlineModalOpen] = useState(false);
  const [previousSelectedPage, setPreviousSelectedPage] = useState([]);
  const [currrentNoteTitle, setCurrentNoteTitle] = useState(undefined);
  const [exportBriefDrpDwnList, setExportBriefDrpDwnList] = useState();
  const [annotationPrintVOList, setAnnotationPrintVOList] = useState([]);
  const [individualPrintLimit, setIndividualPrintLimit] = useState("0.00");
  const [chapterType, setChapterType] = useState(props.bookVO.chapterType);
  const [currentChapterId, setCurrentChapterId] = useState(props.chapterId);
  const [exportChapterDrpDwnList, setExportChapterDrpDwnList] = useState([]);
  const [currrentChapterName, setCurrentChapterName] = useState(
    "Chapter " + props.bookVO.chapterNumber + ": " + props.bookVO.chapterTitle,
  );
  const [labelVOList, setLabelVOList] = useState(
    props.labelVOList
      ? Array.isArray(props.labelVOList)
        ? props.labelVOList
        : [props.labelVOList]
      : undefined,
  );
  useEffect(() => {
    async function fetchHighlightSettings() {
      getChapterListForOutline();
      getChapterLayout(props.chapterId, false);
      getCasesInBook();
    }
    fetchHighlightSettings();
  }, []);
  const getChapterListForOutline = () => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadChapterId: "",
          lastViewedOutlineId: "",
          pageNavigatingTo: "EReader",
          lastReadParagraphId: "para01",
          pageNavigatingFrom: "EReader",
          lastActivityCode: "BOOKSHELF",
          lastReadSubSectionId: "subsec01",
          lastReadBookId: props.bookVO.bookId,
          lastViewedOutlineType: "chapterOutline",
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      outlineVO: {
        bookId: props.bookVO.bookId,
        recentNotesFlag: "allNotes",
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      localStorage.getItem("ENV") + "/manageOutlineService/getOutlineNotes",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data) {
            let chapterList = Array.isArray(data.outlineVO.chapterOutlineVO)
              ? data.outlineVO.chapterOutlineVO
              : [data.outlineVO.chapterOutlineVO];
            let currentCustomOutlineVOList = [];
            if (data.outlineVO.customOutlineVO !== undefined) {
              currentCustomOutlineVOList = Array.isArray(
                data.outlineVO.customOutlineVO,
              )
                ? data.outlineVO.customOutlineVO
                : [data.outlineVO.customOutlineVO];
              setExportNotes(currentCustomOutlineVOList);
              setCurrentNoteId(currentCustomOutlineVOList[0].chapterId);
              setCurrentNoteTitle(currentCustomOutlineVOList[0].chapterTitle);
            }
            setCurrentChapterId(props.bookVO.chapterId);
            setExportChapterDrpDwnList(chapterList);
          }
        } else {
          if (data.wkErrorCode) {
            handleException(data);
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  // function getChapterLayout(chapterId, valueCheck) {
  //     valueCheck ? setOutlineLoading(true) : setOutlineLoading(false);
  //     let reqData = {
  //         "userVO": {
  //             "userId": userVO.userId,
  //             "userRole": userVO.userRole,
  //             "userRoleId": userVO.userRoleId,
  //             "userActivityVO": {
  //                 "lastActivityCode": "BOOKSHELF",
  //                 "pageNavigatingFrom": "ClassInsight",
  //                 "pageNavigatingTo": "Outline",
  //                 "lastReadBookId": props.bookVO.bookId,
  //                 "lastReadChapterId": "",
  //                 "lastReadSubSectionId": "subsec01",
  //                 "lastReadParagraphId": "para01",
  //                 "lastViewedOutlineId": "",
  //                 "lastViewedOutlineType": "chapterOutline"
  //             },
  //             "sessionVO": {
  //                 "appType": "web",
  //                 "deviceMacId": "",
  //                 "keepMeLoggedInFlag": keepMeLogIn,
  //                 "deviceOS": localStorage.getItem('deviceOS'),
  //                 "deviceType": localStorage.getItem('deviceType'),
  //                 "browserName": localStorage.getItem('browserName'),
  //                 "sessionAuthenticationToken": userVO.sessionAuthenticationToken
  //             }
  //         },
  //         "annotationVO": {
  //             "bookId": props.bookVO.bookId,
  //             "chapterId": chapterId !== undefined ? chapterId : "",
  //             "ereaderNotesAndHighlightsPopoverFlowFlag": "true"
  //         }
  //     }
  //     const requestOptions1 = {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
  //         body: JSON.stringify(reqData)
  //     };
  //     fetch(localStorage.getItem('ENV') + "/manageOutlineService/getChapterOutlineRV", requestOptions1)
  //         .then(response => response.json())
  //         .then(data => {
  //             if (data && data.status === "true") {
  //                 if (data.sectionVOList) {
  //                     data.sectionVOList = Array.isArray(data.sectionVOList) ? data.sectionVOList : [data.sectionVOList];
  //                     data.sectionVOList.map(item => {
  //                         if (item.annotationVOList) {
  //                             item.annotationVOList = Array.isArray(item.annotationVOList) ? item.annotationVOList : [item.annotationVOList];
  //                         }
  //                     });
  //                     setSectionVOList(data.sectionVOList);
  //                 }
  //                 if (!firstTimeOutline) { getOutlineContentToDoc() }
  //                 setOutlineLoading(false);
  //             } else {
  //                 if (data.wkErrorCode) {
  //                     handleException(data);
  //                 }
  //             }
  //         }).catch(error => {
  //             setOutlineLoading(false);
  //             console.error("There has been a problem with your fetch operation:", error);
  //         });
  // }
  let outlinesAnnotationList = [];

  async function getChapterLayout(chapterId) {
    setOutlineLoading(true);

    const baseReqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "ClassInsight",
          pageNavigatingTo: "Outline",
          lastReadBookId: props.bookVO.bookId,
          lastReadChapterId: "",
          lastReadSubSectionId: "subsec01",
          lastReadParagraphId: "para01",
          lastViewedOutlineId: "",
          lastViewedOutlineType: "chapterOutline",
        },
        sessionVO: {
          appType: "web",
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          deviceOS: localStorage.getItem("deviceOS"),
          deviceType: localStorage.getItem("deviceType"),
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
    };

    try {
      let allAnnotations = [];
      let totalPages = 1;

      for (let pageNum = 0; pageNum < totalPages; pageNum++) {
        const reqData = {
          ...baseReqData,
          annotationVO: {
            bookId: props.bookVO.bookId,
            chapterId: chapterId ?? "",
            pageNum,
            ereaderNotesAndHighlightsPopoverFlowFlag: "true",
          },
        };

        const res = await fetch(
          `${localStorage.getItem("ENV")}/manageOutlineService/getChapterOutlineRV`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(reqData),
          },
        );

        const data = await res.json();

        if (data.status !== "true") {
          handleException(data);
          setOutlineLoading(false);
          return;
        }

        // collect annotations
        if (data.annotationVOList) {
          const pageAnnotations = Array.isArray(data.annotationVOList)
            ? data.annotationVOList
            : [data.annotationVOList];

          allAnnotations.push(...pageAnnotations);
        }

        // update total pages after first call
        if (pageNum === 0 && data.totalPages) {
          totalPages = Number(data.totalPages);
        }

        // cache sections once
        if (pageNum === 0 && data.sectionVOList) {
          var sectionVOList = Array.isArray(data.sectionVOList)
            ? data.sectionVOList
            : [data.sectionVOList];
        }
      }

      /* -------- GROUP ANNOTATIONS BY SECTION -------- */
      const annotationsBySectionId = allAnnotations.reduce((acc, ann) => {
        const key = String(ann.sectionId);
        if (!acc[key]) acc[key] = [];
        acc[key].push(ann);
        return acc;
      }, {});

      /* -------- INJECT INTO SECTIONS -------- */
      const updatedSectionVOList = sectionVOList.map((section) => {
        const sectionId = String(section.sectionId);

        const annotations = annotationsBySectionId[sectionId] || [];

        const uniqueSortedAnnotations = [
          ...new Map(annotations.map((a) => [a.annotationId, a])).values(),
        ].sort(
          (a, b) =>
            Number(a.highlightStartOffset) - Number(b.highlightStartOffset),
        );

        return {
          ...section,
          annotationVOList: uniqueSortedAnnotations,
        };
      });

      setSectionVOList(updatedSectionVOList);

      if (!firstTimeOutline) {
        getOutlineContentToDoc();
      }

      setOutlineLoading(false);
    } catch (err) {
      console.error("Fetch error:", err);
      setOutlineLoading(false);
    }
  }
  const getContentforNotes = (chapterId, valueCheck) => {
    valueCheck ? setNotepadLoading(true) : setNotepadLoading(false);
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: props.bookVO.bookId,
          lastReadSubSectionId: "subsec01",
          lastReadParagraphId: "para01",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "CASES",
          pageNavigatingTo: "CASES",
        },
        sessionVO: {
          appType: "web",
          deviceType: localStorage.getItem("deviceType"),
          deviceOS: localStorage.getItem("deviceOS"),
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      annotationVO: {
        bookId: props.bookVO.bookId,
        customOutlineId: chapterId !== undefined ? chapterId : "",
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      localStorage.getItem("ENV") +
        "/manageOutlineService/getAnnotationsForCustomOutline",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data) {
            setNotesContent(
              data.annotationVOList !== undefined
                ? data.annotationVOList.customAnnotationText != undefined
                  ? data.annotationVOList.customAnnotationText
                  : " "
                : " ",
            );
            if (!firstTimeNotes) {
              getNotesContentoDoc();
            }
            setNotepadLoading(false);
          }
        } else {
          if (data.wkErrorCode) {
            handleException(data);
          }
        }
        setNotepadLoading(false);
      })
      .catch((error) => {
        setNotepadLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const onChangeChapterEvent = (e) => {
    firstTimeOutline = true;
    setCurrentChapterId(e.target.value);
    setCurrentChapterName(
      document.querySelector("#exportChpaterListDrpDwn option:checked")
        .textContent,
    );
    getChapterLayout(e.target.value, true);
  };
  const onChangeNotesEvent = (e) => {
    firstTimeNotes = true;
    setCurrentNoteId(e.target.value);
    setCurrentNoteTitle(
      document.querySelector("#exportNotesListDrpDwn option:checked")
        .textContent,
    );
    getContentforNotes(e.target.value, true);
  };
  const getLatestNotesDrpdwn = () => {
    setIsNoteModalOpen(true);
    getChapterListForOutline();
  };
  const getLatestNotes = (e) => {
    if (!firstTimeNotes) {
      getContentforNotes(currentNoteId, true);
    } else {
      getNotesContentoDoc();
    }
  };
  const getLatestOutline = (e) => {
    if (!firstTimeOutline) {
      getChapterLayout(currentChapterId, true);
    } else {
      getOutlineContentToDoc();
    }
  };
  const getLatestBrief = (e) => {
    if (!firstTimeBrief) {
      let val = $("#exportBriefListDrpDwn").val();
      getChapterBrief(currentChapterId, val, true);
    } else {
      getBriefContentToDoc();
    }
  };
  const getOutlineContentToDoc = () => {
    // if (document.querySelector('#exportChpaterListDrpDwn option:checked') != null) {
    //     setCurrentChapterName(document.querySelector('#exportChpaterListDrpDwn option:checked').textContent);
    // }

    let selectedChapterName = "";

    const selectedOption = document.querySelector(
      "#exportChpaterListDrpDwn option:checked",
    );

    if (selectedOption) {
      selectedChapterName = selectedOption.textContent;
    }

    let header1 =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
      "xmlns:w='urn:schemas-microsoft-com:office:word' " +
      "xmlns='http://www.w3.org/TR/REC-html40'>" +
      "<head><meta charset='utf-8'><title>Export Outline</title></head><body>";
    let footer1 = "</body></html>";
    let htmlInput = document.getElementById("ExportOutline").innerHTML;
    htmlInput = htmlInput
      .replace(/<br>/g, "<br/>")
      .replace(/&nbsp;/g, " ")
      .replace(/&ldquo;/g, '"')
      .replace(/&rdquo;/g, '"')
      .replace(/&lsquo;/g, "'")
      .replace(/&rsquo;/g, "'")
      .replace(/&sect;/g, "ยง")
      .replace(/&amp;/g, "&");
    let sourceHTML1 = header1 + htmlInput + footer1;
    let source1 =
      "data:application/vnd.ms-word;charset=utf-8," +
      encodeURIComponent(sourceHTML1);
    let fileDownload1 = document.createElement("a");
    document.body.appendChild(fileDownload1);
    fileDownload1.href = source1;
    // fileDownload1.download =
    //   currrentChapterName.toString() + "_OutlineNotes" + ".doc";
    fileDownload1.download = selectedChapterName + "_OutlineNotes.doc";
    fileDownload1.click();
    document.body.removeChild(fileDownload1);
    hideExportOutLineModal();
  };
  const getNotesContentoDoc = () => {
    setCurrentNoteTitle(
      document.querySelector("#exportNotesListDrpDwn option:checked")
        .textContent,
    );
    let header1 =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
      "xmlns:w='urn:schemas-microsoft-com:office:word' " +
      "xmlns='http://www.w3.org/TR/REC-html40'>" +
      "<head><meta charset='utf-8'><title>Export Notepad</title></head><body>";
    let footer1 = "</body></html>";
    let htmlInput = document.getElementById("ExportNotes").innerText;
    if (htmlInput) {
      htmlInput = htmlInput
        .replace(/<br>/g, "<br/>")
        .replace(/&nbsp;/g, " ")
        .replace(/&ldquo;/g, '"')
        .replace(/&rdquo;/g, '"')
        .replace(/&lsquo;/g, "'")
        .replace(/&rsquo;/g, "'")
        .replace(/&sect;/g, "ยง")
        .replace(/&amp;/g, "&");
    }
    let sourceHTML1 = header1 + htmlInput + footer1;
    let source1 =
      "data:application/vnd.ms-word;charset=utf-8," +
      encodeURIComponent(sourceHTML1);
    let fileDownload1 = document.createElement("a");
    document.body.appendChild(fileDownload1);
    fileDownload1.href = source1;
    fileDownload1.download = currrentNoteTitle.toString() + ".doc";

    fileDownload1.click();
    document.body.removeChild(fileDownload1);
    hideExportNotepadModal();
  };
  const getChapterBrief = (inputChapterId, inputSectionId, valchk) => {
    valchk ? setCasebriefLoading(true) : setCasebriefLoading(false);
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: props.bookVO.bookId,
          lastReadChapterId: inputChapterId,
          lastReadSectionId: inputSectionId,
          lastReadSubSectionId: "subsec01",
          lastReadParagraphId: "para01",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "CASES",
          pageNavigatingTo: "CASES",
        },
        sessionVO: {
          appType: "web",
          deviceType: localStorage.getItem("deviceType"),
          deviceOS: localStorage.getItem("deviceOS"),
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      briefVO: {
        pageNum: "0",
        bookId: props.bookVO.bookId,
        chapterId: inputChapterId,
        ereaderNotesAndHighlightsPopoverFlowFlag: false,
        sectionId: inputSectionId,
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      localStorage.getItem("ENV") + "/manageCases/getMyBriefContent",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data) {
            if (data.labelVOList) {
              let briefLabelVOList = Array.isArray(data.labelVOList)
                ? data.labelVOList
                : [data.labelVOList];
              setLabelVOList(briefLabelVOList);
              if (!firstTimeBrief) {
                getBriefContentToDoc();
              }
            } else {
              setLabelVOList(null);
            }
          }
        } else {
          if (data.wkErrorCode) {
            handleException(data);
          }
        }
        setCasebriefLoading(false);
      })
      .catch((error) => {
        setCasebriefLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const getCasesInBook = () => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        streamContentRequiredFlag: false,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "Bookshelf",
          pageNavigatingTo: "BOOKSHELF",
          lastReadBookId: props.bookVO.bookId,
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadSubSectionId: "",
          lastReadParagraphId: "",
          lastViewedOutlineId: "",
        },
        sessionVO: {
          appType: "web",
          deviceType: localStorage.getItem("deviceType"),
          deviceOS: localStorage.getItem("deviceOS"),
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      bookVO: {
        bookId: props.bookVO.bookId,
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      localStorage.getItem("ENV") + "/manageCases/getAllPrincipleCaseByBookId",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data && data.status === "true") {
          if (data.chapterVOList) {
            data.chapterVOList = Array.isArray(data.chapterVOList)
              ? data.chapterVOList
              : [data.chapterVOList];
            data.chapterVOList.map((chaptVo) => {
              if (chaptVo.sectionVOList) {
                chaptVo.sectionVOList = Array.isArray(chaptVo.sectionVOList)
                  ? chaptVo.sectionVOList
                  : [chaptVo.sectionVOList];
              }
            });
            handleDefaultChapterBrief(data.chapterVOList);
            setExportBriefDrpDwnList(data.chapterVOList);
          }
        } else {
          if (data.wkErrorCode) {
            handleException(data);
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const handleDefaultChapterBrief = (chapterVoList) => {
    var principalCasechapterVO = chapterVoList,
      paramChaptId = chapterId,
      isParamChaptId = false;
    let defaultChaptId, defaultsectId;
    if (paramChaptId) {
      principalCasechapterVO.map(({ chapterId, sectionVOList }) => {
        if (chapterId === paramChaptId) {
          isParamChaptId = true;
          defaultChaptId = chapterId;
          defaultsectId = sectionVOList[0].sectionId;
          setPCaseNavTitle(sectionVOList[0].sectionTitle);
          setPCaseSectionId(defaultsectId);
          return false;
        }
      });
      if (!isParamChaptId) {
        defaultChaptId = principalCasechapterVO[0].chapterId;
        defaultsectId = principalCasechapterVO[0].sectionVOList[0].sectionId;
        setPCaseNavTitle(
          principalCasechapterVO[0].sectionVOList[0].sectionTitle,
        );
        setPCaseSectionId(defaultsectId);
      }
      getChapterBrief(defaultChaptId, defaultsectId, true);
    }
  };
  const onChangeBriefEvent = (e) => {
    firstTimeBrief = true;
    let selectedChaptId =
        e.nativeEvent.target[e.nativeEvent.target.selectedIndex].attributes[
          "chapterId"
        ].value,
      selectedSectId = e.target.value;
    setPCaseNavTitle(
      e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text,
    );
    setPCaseSectionId(e.target.value);
    getChapterBrief(selectedChaptId, selectedSectId, true);
  };
  const getBriefContentToDoc = () => {
    let header =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
      "xmlns:w='urn:schemas-microsoft-com:office:word' " +
      "xmlns='http://www.w3.org/TR/REC-html40'>" +
      "<head><meta charset='utf-8'><title>Export Case Brief</title></head><body>";
    let footer = "</body></html>";
    let html = document.getElementById("briefNotesExport").innerHTML;
    let html1 = html
      .replace(/<br>/g, "<br/>")
      .replace(/&nbsp;/g, " ")
      .replace(/&ldquo;/g, '"')
      .replace(/&rdquo;/g, '"')
      .replace(/&lsquo;/g, "'")
      .replace(/&rsquo;/g, "'")
      .replace(/&sect;/g, "??")
      .replace(/&amp;/g, "&")
      .replace(
        "<div class='brief-label-title'>",
        "<h1 class='brief-label-title'>",
      )
      .replace(
        '<div style="width: 49%;height:40px;" class="display-inline-block dropdown  case-right">',
        '<div style="width: 49%;height:40px; display:none" class="display-inline-block dropdown  case-right">',
      );
    let sourceHTML = header + html1 + footer;
    let source =
      "data:application/vnd.ms-word;charset=utf-8," +
      encodeURIComponent(sourceHTML);
    let fileDownload = document.createElement("a");
    document.body.appendChild(fileDownload);
    fileDownload.href = source;
    fileDownload.download = pCaseNavTitle.toString() + ".doc";
    fileDownload.click();
    document.body.removeChild(fileDownload);
    hideExportCaseBriefsModal();
  };
  const showPrintModal = () => {
    relatedHighLightTags = $("highlight");
    relatedNotesSpanTag = $(".notesSpanBlock");
    relatedBriefTags = $("briefsTag");
    relatedBriefSpanTag = $(".briefSpanBlock");
    setIsPrintModalOpen(true);
    let printContent = document.getElementById("ereader-container");
    if (printContent && printContent.innerHTML) {
      setPrintContent(printContent.innerHTML);
    }
    getSectionListByChapterId();
    getUserPrintDetails();
    getChapterOutineForPrint();
    if (chapterType === "supplemental") {
      setSelectableShow(false);
    } else {
      setSelectableShow(true);
    }
    setFontSizePrint("14");
  };
  const getSectionListByChapterId = () => {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "EReader",
          lastReadBookId: props.bookVO.bookId,
          lastReadChapterId: "",
          lastReadSubSectionId: "subsec01",
          lastReadParagraphId: "para01",
          lastViewedOutlineId: "",
          lastViewedOutlineType: "chapterOutline",
        },
        sessionVO: {
          appType: "web",
          deviceType: localStorage.getItem("deviceType"),
          deviceOS: localStorage.getItem("deviceOS"),
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      bookVO: {
        bookId: props.bookVO.bookId,
      },
      chapterVO: {
        chapterId: currentChapterId !== undefined ? currentChapterId : "",
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      localStorage.getItem("ENV") +
        "/manageBookService/getSectionListByChapterId",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data) {
            if (typeof data.sectionVOList !== "undefined") {
              data.sectionVOList = Array.isArray(data.sectionVOList)
                ? data.sectionVOList
                : [data.sectionVOList];
              for (let i = 0; i < data.sectionVOList.length; i++) {
                if (data.sectionVOList[i].sectionTitle === "Table Of Content") {
                  data.sectionVOList[i].sectionTitle = "Table of Contents";
                }
                if (data.sectionVOList[i].childSectionIdVOList) {
                  if (
                    $.type(data.sectionVOList[i].childSectionIdVOList) ===
                    "object"
                  ) {
                    let arrEle = [];
                    arrEle.push(data.sectionVOList[i].childSectionIdVOList);
                    data.sectionVOList[i].childSectionIdVOList = arrEle;
                  }
                }
              }
              for (let i in data.sectionVOList) {
                if (
                  data.sectionVOList[i].orderIndex === "1" &&
                  data.sectionVOList[i].sectionTitle === "-999"
                ) {
                  let localTocLen = $(
                      "#" + data.sectionVOList[i].sectionId,
                    ).prev()[0].classList.length,
                    localToc1 = "";
                  if (localTocLen === 1) {
                    localToc1 = $(
                      "#" + data.sectionVOList[i].sectionId,
                    ).prev()[0].classList[0];
                  } else {
                    localToc1 = $(
                      "#" + data.sectionVOList[i].sectionId,
                    ).prev()[0].classList[1];
                  }
                  if (localToc1 !== undefined) {
                    if (
                      localToc1 === "cc-localtoc" ||
                      localToc1 === "epub-localToc"
                    ) {
                      if (
                        $("#" + data.sectionVOList[i].sectionId)
                          .html()
                          .trim() !== ""
                      ) {
                        data.sectionVOList[i].sectionTitle = "IntroductoryText";
                        data.sectionVOList[i].sectionType = "intro-section";
                        $(
                          "#print-content-modal #" +
                            data.sectionVOList[i].sectionId,
                        ).addClass("cc-section-title");
                        $(
                          "#print-content-modal #" +
                            data.sectionVOList[i].sectionId,
                        ).addClass("cc-intro-section");
                        break;
                      }
                    }
                  }
                }
              }
              for (let i in data.sectionVOList) {
                if (data.sectionVOList[i].sectionTitle === "-999") {
                  if (
                    $("#" + data.sectionVOList[i].sectionId).hasClass(
                      "epub-nepq",
                    ) ||
                    $("#" + data.sectionVOList[i].sectionId).hasClass(
                      "epub-ahead",
                    )
                  ) {
                    let prevDivId = $(
                        "#print-content-modal #" +
                          data.sectionVOList[i].sectionId,
                      ).prev()[0].id,
                      nepqFlag = true,
                      eleDetach = "",
                      introSection = "";
                    let prevDivClass = $(
                      "#print-content-modal #" + prevDivId,
                    )[0].classList[1];
                    if (prevDivClass !== undefined) {
                      while (nepqFlag) {
                        if (
                          prevDivClass === "epub-ahead" ||
                          $("#print-content-modal #" + prevDivId).hasClass(
                            "cc-intro-section",
                          )
                        ) {
                          eleDetach = $(
                            "#print-content-modal #" +
                              data.sectionVOList[i].sectionId,
                          ).html();
                          $(
                            "#print-content-modal #" +
                              data.sectionVOList[i].sectionId,
                          ).remove();
                          $("#print-content-modal #" + prevDivId).append(
                            eleDetach,
                          );
                          nepqFlag = false;
                        } else if (prevDivClass === "cc-pagenum-begin") {
                          prevDivId = $(
                            "#print-content-modal #" +
                              data.sectionVOList[i].sectionId,
                          )
                            .prev()
                            .prev()[0].id;
                          prevDivClass = $(
                            "#print-content-modal #" + prevDivId,
                          )[0].classList[1];
                          if (prevDivClass === "epub-ahead") {
                            continue;
                          } else if (
                            $("#print-content-modal").find(
                              ".cc-intro-section",
                            )[0].id !== undefined
                          ) {
                            prevDivId = $("#print-content-modal").find(
                              ".cc-intro-section",
                            )[0].id;
                            prevDivClass = $(
                              "#print-content-modal #" + prevDivId,
                            )[0].classList[1];
                            continue;
                          }
                        } else {
                          prevDivId = $(
                            "#print-content-modal #" +
                              data.sectionVOList[i].sectionId,
                          )
                            .prev()
                            .prev()[0].id;
                          prevDivClass = $(
                            "#print-content-modal #" + prevDivId,
                          )[0].classList[1];
                          continue;
                        }
                      }
                    }
                  }
                } else {
                  let secTitle = data.sectionVOList[i].sectionTitle;
                  data.sectionVOList[i].sectionTitle = secTitle.replace(
                    /[^a-z0-9,. ]/gi,
                    "",
                  );
                }
                if (data.sectionVOList[i].childSectionIdVOList) {
                  for (let j in data.sectionVOList[i].childSectionIdVOList) {
                    if (
                      data.sectionVOList[i].childSectionIdVOList[j]
                        .sectionTitle === "-999"
                    ) {
                      let eleDetach = "";
                      if (
                        data.sectionVOList[i].sectionTitle ===
                        "IntroductoryText"
                      ) {
                        eleDetach = $(
                          "#" +
                            data.sectionVOList[i].childSectionIdVOList[j]
                              .sectionId,
                        ).html();
                        if (
                          $(
                            "#print-content-modal #" +
                              data.sectionVOList[i].childSectionIdVOList[j]
                                .parentSectionId +
                              ".cc-intro-section",
                          )[0] !== undefined
                        ) {
                          $(
                            "#print-content-modal #" +
                              data.sectionVOList[i].childSectionIdVOList[j]
                                .sectionId,
                          ).remove();
                          $(
                            "#print-content-modal #" +
                              data.sectionVOList[i].childSectionIdVOList[j]
                                .parentSectionId +
                              ".cc-intro-section",
                          ).append(eleDetach);
                        }
                      } else {
                        eleDetach = $(
                          "#" +
                            data.sectionVOList[i].childSectionIdVOList[j]
                              .sectionId,
                        ).html();
                        if (
                          $(
                            "#print-content-modal #" +
                              data.sectionVOList[i].childSectionIdVOList[j]
                                .parentSectionId +
                              " .cc-section-title",
                          )[0] !== undefined
                        ) {
                          $(
                            "#print-content-modal #" +
                              data.sectionVOList[i].childSectionIdVOList[j]
                                .sectionId,
                          ).remove();
                          if (
                            $(
                              "#print-content-modal #" +
                                data.sectionVOList[i].childSectionIdVOList[j]
                                  .parentSectionId +
                                " .cc-section-title",
                            ).length === 1
                          ) {
                            $(
                              "#print-content-modal #" +
                                data.sectionVOList[i].childSectionIdVOList[j]
                                  .parentSectionId +
                                " .cc-section-title",
                            ).append(eleDetach);
                          } else {
                            $(
                              "#print-content-modal #" +
                                data.sectionVOList[i].childSectionIdVOList[j]
                                  .parentSectionId +
                                " .cc-section-title:first",
                            ).append(eleDetach);
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            setSectionPrintVOList(data.sectionVOList);
            data.sectionVOList.map((item1, key1) => {
              let element = {};
              element.id = item1.sectionId;
              element.type = item1.sectionType;
              element.name = "sectionA" + item1.sectionId;
              sectionList.push(element);
            });
            data.sectionVOList.map((item2, key2) => {
              if (item2.childSectionIdVOList) {
                item2.childSectionIdVOList.map((item3, key3) => {
                  let element1 = {};
                  element1.id = item3.sectionId;
                  element1.type = item3.sectionType;
                  element1.name = "sectionB" + item3.sectionId;
                  sectionList.push(element1);
                });
              }
            });
            sectionList.forEach((sec) => {
              setCheckedItems((prevState) => ({
                ...prevState,
                [sec.name]: false,
              }));
            });
            setLoading(false);
          }
        } else {
          if (data.wkErrorCode) {
            handleException(data);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const getUserPrintDetails = () => {
    setPrintPageLoading(true);
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "Outline",
          lastReadBookId: props.bookVO.bookId,
          lastReadChapterId: "",
          lastReadSubSectionId: "subsec01",
          lastReadParagraphId: "para01",
          lastViewedOutlineId: "",
          lastViewedOutlineType: "chapterOutline",
        },
        sessionVO: {
          appType: "web",
          deviceType: localStorage.getItem("deviceType"),
          deviceOS: localStorage.getItem("deviceOS"),
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      bookVO: {
        bookId: props.bookVO.bookId,
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      localStorage.getItem("ENV") + "/manageBookService/getUserPrintDetails",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data.bookVO) {
            if (data.bookVO.totalNumberOfPages) {
              setTotalNumberOfPages(data.bookVO.totalNumberOfPages);
            }
            if (data.bookVO.individualPrintLimit) {
              setIndividualPrintLimit(data.bookVO.individualPrintLimit);
            } else {
              setIndividualPrintLimit(data.bookVO.printLimit);
            }
            if (data.bookVO.printedPageList) {
              setPreviousSelectedPage(data.bookVO.printedPageList);
            } else {
              setPreviousSelectedPage([]);
            }
            if (data.bookVO.printedPercentage) {
              setPrevPrint(
                parseFloat(data.bookVO.printedPercentage).toFixed(2),
              );
            } else {
              setPrevPrint("0.00");
            }
          } else {
            setPreviousSelectedPage([]);
          }
        } else {
          if (data.wkErrorCode) {
            handleException(data);
          }
        }
        setPrintPageLoading(false);
      })
      .catch((error) => {
        setPrintPageLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  function getChapterOutineForPrint() {
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "EReader",
          lastReadBookId: props.bookVO.bookId,
          lastReadChapterId: "",
          lastReadSubSectionId: "subsec01",
          lastReadParagraphId: "para01",
          lastViewedOutlineId: "",
          lastViewedOutlineType: "chapterOutline",
        },
        sessionVO: {
          appType: "web",
          deviceType: localStorage.getItem("deviceType"),
          deviceOS: localStorage.getItem("deviceOS"),
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      annotationVO: {
        bookId: props.bookVO.bookId,
        chapterId: "",
        ereaderNotesAndHighlightsPopoverFlowFlag: "true",
      },
      bookVO: {
        bookId: props.bookVO.bookId,
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      localStorage.getItem("ENV") + "/manageOutlineService/getChapterOutlineRV",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data.sectionVOList) {
            data.sectionVOList = Array.isArray(data.sectionVOList)
              ? data.sectionVOList
              : [data.sectionVOList];
            data.sectionVOList.map((item) => {
              if (item.annotationVOList) {
                item.annotationVOList = Array.isArray(item.annotationVOList)
                  ? item.annotationVOList
                  : [item.annotationVOList];
              }
            });
            setAnnotationPrintVOList(data.sectionVOList);
          }
          setOutlineLoading(false);
        } else {
          if (data.wkErrorCode) {
            handleException(data);
          }
        }
      })
      .catch((error) => {
        setOutlineLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  }
  useEffect(() => {
    calcPrint();
  }, [prevPrint]);
  const calcPrint = () => {
    let prePrinted = parseFloat(prevPrint);
    let totalAllow = parseFloat(individualPrintLimit);
    let totalPage = parseFloat(totalNumberOfPages);
    let pageNum = [];
    resultSet = [];
    let pageNumList = $(
      "#print-tab-section-container .cc-pagenum-begin:visible",
    );
    pageNumList.each(function () {
      pageNum.push(this.getAttribute("title"));
    });
    pageNum = [...new Set(pageNum)];
    let c = pageNum.concat(previousSelectedPage);
    resultSet = [...new Set(c)];
    let currntSel = pageNum.filter(function (l) {
      return previousSelectedPage.indexOf(l) < 0;
    });
    let avg = parseFloat((currntSel.length / totalPage) * 100);
    setCurrSelection(parseFloat(avg).toFixed(2));
    let remainingPer = parseFloat(totalAllow - (avg + prePrinted));
    if (remainingPer <= 0) {
      if (prePrinted == "30.00") {
        if (currntSel.length == 0) {
          setPrintError(true);
          setBtnDisabled(true);
        } else {
          setPrintError(false);
          setBtnDisabled(false);
        }
      } else {
        setPrintError(true);
        setBtnDisabled(true);
      }
      setPrintAllowance("0.00");
    } else {
      setPrintError(false);
      setBtnDisabled(false);
      setPrintAllowance(parseFloat(remainingPer).toFixed(2));
    }
  };
  const printPageSection = (e) => {
    setCheckedItems({ ...checkedItems, [e.target.name]: !e.target.checked });
    let id = e.currentTarget.getAttribute("data-id");
    let sectionOrPCase = e.currentTarget.getAttribute("data-type");
    if (sectionOrPCase.toString() === "-999") {
      sectionOrPCase = "C";
    }
    let idList = [];
    idList = getHighlightOrBriefIds(id);
    if ($("#" + e.currentTarget.id).prop("checked") == true) {
      let pid = 0;
      if (
        sectionOrPCase == "A" ||
        sectionOrPCase == "B" ||
        sectionOrPCase == "intro-section"
      ) {
        if (id == "epub-localToc") {
          $("#print-tab-section-container ." + id).show();
          $("#print-tab-section-container .cc-localToc").show();
          let classInd = noPrintSectionList.indexOf(id);
          if (classInd != -1) {
            noPrintSectionList.splice(classInd, 1);
          }
        } else if (sectionOrPCase === "intro-section") {
          if (
            $("#print-content-modal #" + id).find(".cc-section-title")[0] ===
              undefined &&
            $("#print-content-modal #" + id).find(
              ".cc-principalCase-title",
            )[0] === undefined
          ) {
            $("#print-tab-section-container #" + id)
              .children()
              .show();
          } else {
            $("#print-tab-section-container #" + id)
              .children()
              .not(".cc-section")
              .show();
          }
          let classInd = noPrintSectionList.indexOf(id);
          if (classInd != -1) {
            noPrintSectionList.splice(classInd, 1);
          }
        } else {
          if (
            $("#print-tab-section-container #" + id)
              .parent()
              .parent()
              .find(".epub-outline")[0] !== undefined
          ) {
            $("#print-tab-section-container #" + id)
              .parent()
              .parent()
              .find(".epub-outline")
              .show();
          }
          $("#print-tab-section-container #" + id)
            .children()
            .not(".cc-section")
            .show();
          let sec = $("#print-tab-section-container #" + id)
            .children()
            .not(".cc-section");
          let indexSecList = noPrintSectionList.indexOf(id);
          if (indexSecList != -1) {
            noPrintSectionList.splice(indexSecList, 1);
          }
          let idLt, clName;
          for (let i = 0; i < sec.length; i++) {
            idLt = sec[i].id;
            if (idLt == "") {
              let list = [],
                idhEle = "",
                idbEle = "";
              $(sec[i]).each(function () {
                $(this)
                  .find("highlight")
                  .each(function () {
                    idhEle = $(this).attr("id");
                    list.push(idhEle);
                  });
                $(this)
                  .find("briefstag")
                  .each(function () {
                    idbEle = $(this).attr("id");
                    list.push(idbEle);
                  });
              });
              if (list.length > 0) {
                showNotesMargin(list);
              }
            } else {
              let idLst = getHighlightOrBriefIds(idLt);
              if (idLst.length > 0) {
                showNotesMargin(idLst);
              }
            }
            if ($(sec[i].childNodes).hasClass("cc-principal-case")) {
              $(sec[i]).show();
              $(sec[i].childNodes).not(".cc-section").show();
              $(sec[i].childNodes).each(function () {
                if ($(this)[0].className != undefined) {
                  if ($(this)[0].className.indexOf("cc-section") != -1) {
                    let idList = getHighlightOrBriefIds($(this)[0].id);
                    let disp = $("#chapter-section-list")
                      .find("[data-id='" + $(this)[0].id + "'] input")
                      .prop("checked");
                    if (disp) {
                      if (idList.length > 0) {
                        showNotesMargin(idList);
                      }
                    } else {
                      if (idList.length > 0) {
                        hideNotesMargin(idList);
                      }
                    }
                  }
                }
              });
            }
          }
        }
      }
      if (sectionOrPCase == "pCase" || sectionOrPCase == "C") {
        $("#print-tab-section-container #" + id).show();
        if (idList.length > 0) {
          showNotesMargin(idList);
        }
        let index = noPrintSectionList.indexOf(id);
        if (index != -1) {
          noPrintSectionList.splice(index, 1);
        }
        if (
          !$("#print-tab-section-container #" + id)
            .parent()
            .hasClass("cc-section")
        ) {
          $("#print-tab-section-container #" + id)
            .parent()
            .show();
          let disp = $("#print-tab-section-container #" + id)
            .parent()
            .css("display");
          if (disp == "hide") {
            $("#print-tab-section-container #" + id)
              .parent()
              .children()
              .not(".cc-section")
              .hide();
          }
        }
      }
    } else {
      let pid = 0;
      if (
        sectionOrPCase == "A" ||
        sectionOrPCase == "B" ||
        sectionOrPCase === "intro-section"
      ) {
        if (id == "epub-localToc") {
          $("#print-tab-section-container ." + id).hide();
          $("#print-tab-section-container .cc-localToc").hide();
          let index = noPrintSectionList.indexOf(id);
          if (index == -1) {
            noPrintSectionList.push(id);
          }
        } else if (sectionOrPCase === "intro-section") {
          if (
            $("#print-content-modal #" + id).find(".cc-section-title")[0] ===
              undefined &&
            $("#print-content-modal #" + id).find(
              ".cc-principalCase-title",
            )[0] === undefined
          ) {
            $("#print-tab-section-container #" + id)
              .children()
              .hide();
          } else {
            $("#print-tab-section-container #" + id)
              .children()
              .not(".cc-section")
              .hide();
          }
          let index = noPrintSectionList.indexOf(id);
          if (index == -1) {
            noPrintSectionList.push(id);
          }
        } else {
          if (
            $("#print-tab-section-container #" + id)
              .parent()
              .parent()
              .find(".epub-outline")[0] !== undefined
          ) {
            $("#print-tab-section-container #" + id)
              .parent()
              .parent()
              .find(".epub-outline")
              .hide();
          }
          $("#print-tab-section-container #" + id)
            .children()
            .not(".cc-section")
            .hide();
          let sec = $("#print-tab-section-container #" + id)
            .children()
            .not(".cc-section");
          let index = noPrintSectionList.indexOf(id);
          if (index == -1) {
            noPrintSectionList.push(id);
          }
          let idLt, clName;
          for (let i = 0; i < sec.length; i++) {
            idLt = sec[i].id;
            if (idLt == "") {
              let list = [],
                idhEle = "",
                idbEle = "";
              $(sec[i]).each(function () {
                $(this)
                  .find("highlight")
                  .each(function () {
                    idhEle = $(this).attr("id");
                    list.push(idhEle);
                  });
                $(this)
                  .find("briefstag")
                  .each(function () {
                    idbEle = $(this).attr("id");
                    list.push(idbEle);
                  });
              });
              if (list.length > 0) {
                hideNotesMargin(list);
              }
            } else {
              let idLst = getHighlightOrBriefIds(idLt);
              if (idLst.length > 0) {
                hideNotesMargin(idLst);
              }
            }
            if ($(sec[i].childNodes).hasClass("cc-principal-case")) {
              $(sec[i]).show();
              $(sec[i].childNodes).not(".cc-section").hide();
              $(sec[i].childNodes).each(function () {
                if ($(this)[0].className != undefined) {
                  if ($(this)[0].className.indexOf("cc-section") != -1) {
                    let idList = getHighlightOrBriefIds($(this)[0].id);
                    let disp = $("#chapter-section-list")
                      .find("[data-id='" + $(this)[0].id + "'] input")
                      .prop("checked");
                    if (disp) {
                      if (idList.length > 0) {
                        showNotesMargin(idList);
                      }
                    } else {
                      if (idList.length > 0) {
                        hideNotesMargin(idList);
                      }
                    }
                  }
                }
              });
            }
          }
        }
      }
      if (sectionOrPCase == "pCase" || sectionOrPCase == "C") {
        $("#print-tab-section-container #" + id).hide();
        if (idList.length > 0) {
          hideNotesMargin(idList);
        }
        let index = noPrintSectionList.indexOf(id);
        if (index == -1) {
          noPrintSectionList.push(id);
        }
        if (
          !$("#print-tab-section-container #" + id)
            .parent()
            .hasClass("cc-section")
        ) {
          let disp = $("#print-tab-section-container #" + id)
            .parent()
            .css("display");
          if (disp == "hide") {
            $("#print-tab-section-container #" + id)
              .parent()
              .show();
            $("#print-tab-section-container #" + id)
              .parent()
              .children()
              .not(".cc-section")
              .show();
          }
        }
      }
    }
    calcPrint();
  };
  const getHighlightOrBriefIds = (id) => {
    let list = [],
      idhEle = "",
      idbEle = "";
    $("#print-tab-section-container #" + id).each(function () {
      $(this)
        .find("highlight")
        .each(function () {
          idhEle = $(this).attr("id");
          list.push(idhEle);
        });
      $(this)
        .find("briefstag")
        .each(function () {
          idbEle = $(this).attr("id");
          list.push(idbEle);
        });
    });
    return list;
  };
  const showNotesMargin = (list) => {
    $.each(list, function (index, value) {
      let highlight = "anchorElement" + value;
      let brief = "briefAnchorElement" + value;
      $("#print-tab-section-container #notes-container #" + highlight).show();
      $("#print-tab-section-container #notes-container #" + brief).show();
    });
  };
  const hideNotesMargin = (list) => {
    $.each(list, function (index, value) {
      let highlight = "anchorElement" + value;
      let brief = "briefAnchorElement" + value;
      $("#print-tab-section-container #notes-container #" + highlight).hide();
      $("#print-tab-section-container #notes-container #" + brief).hide();
    });
  };
  // Add inline page-break hints to elements that visually read as a "box" (sidebar, feature
  // box, figure) so the print engine keeps each one on a single page. Boxes are identified by
  // their computed border/background at render time - not by class name, which differs per book
  // and lives in external epub CSS we don't control. Elements taller than about a page are left
  // alone because the browser cannot keep them whole anyway.
  const markPrintBoxesToAvoidBreak = (rootSelector) => {
    try {
      const root = document.querySelector(rootSelector);
      if (!root) return;
      const els = root.querySelectorAll(
        "div,section,aside,figure,table,blockquote",
      );
      els.forEach((el) => {
        const cs = window.getComputedStyle(el);
        const hasBorder =
          (parseFloat(cs.borderTopWidth) > 0 && cs.borderTopStyle !== "none") ||
          (parseFloat(cs.borderLeftWidth) > 0 &&
            cs.borderLeftStyle !== "none") ||
          (parseFloat(cs.borderRightWidth) > 0 &&
            cs.borderRightStyle !== "none") ||
          (parseFloat(cs.borderBottomWidth) > 0 &&
            cs.borderBottomStyle !== "none");
        const bg = cs.backgroundColor;
        const hasBg =
          !!bg && bg !== "transparent" && bg !== "rgba(0, 0, 0, 0)";
        // ~900px ≈ one printable page height at 96dpi; skip anything taller.
        const fitsOnPage = el.offsetHeight > 0 && el.offsetHeight < 900;
        if ((hasBorder || hasBg) && fitsOnPage) {
          el.style.pageBreakInside = "avoid";
          el.style.breakInside = "avoid";
        }
      });
    } catch (e) {}
  };
  const printReadPlugin = () => {
    let hgt, maxhgt, ereaderScroller, divElements;
    let chapTitle = $(".cc-nav-title").html();
    let dt = new Date().toJSON().slice(0, 10).split("-");
    let todayDt = dt[1] + "-" + dt[2] + "-" + dt[0];
    let user = userVO.email;
    let cont =
      "Printed by " +
      user +
      " from CasebookConnect.com for personal use only. Redistribution is strictly prohibited.";
    let waterMarkCont = "Redistribution prohibited";
    let waterMarkSubCont = user;
    let browser = (() => {
      let N = navigator.appName,
        ua = navigator.userAgent,
        tem;
      let M = ua.match(
        /(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i,
      );
      if (M && (tem = ua.match(/version\/([\.\d]+)/i)) != null) {
        M[2] = tem[1];
      }
      M = M ? [M[1], M[2]] : [N, navigator.appVersion, "-?"];
      return M;
    })();
    let browserName = $.trim(browser[0].toLowerCase());
    // Tag boxed content (sidebars, feature boxes, figures) so it isn't split across a page
    // boundary. We detect boxes by how they actually render - a visible border or background -
    // rather than by class name, because the book's box classes live in external epub CSS and
    // vary between titles. Must run BEFORE the innerHTML is captured below so the inline
    // page-break hints are included in what gets printed.
    markPrintBoxesToAvoidBreak(".modal-content #print-tab-section-container");
    if (browserName == "chrome" || browserName == "safari") {
      hgt = $(
        ".modal-content #print-tab-section-container #ereader-scroller",
      ).css("height");
      maxhgt = $(
        ".modal-content #print-tab-section-container #ereader-scroller",
      ).css("max-height");
      ereaderScroller = $(".modal-content #print-tab-section-container");
      ereaderScroller.find("#ereader-scroller").removeAttr("style");
      divElements = ereaderScroller.html();
    } else {
      divElements = $(
        ".modal-content #print-tab-section-container #ereader-scroller .ereader-content",
      ).html();
    }
    saveUserPrintDetails();
    let printWindow = window.open(
      localStorage.getItem("BASE_URL"),
      localStorage.getItem("BASE_URL"),
      "",
    );
    // Build the book's stylesheet <link>s dynamically from the runtime EPUB CDN config, matching
    // exactly what the on-screen reader loads (see public/index.html). The old code hardcoded a
    // dead host (d1vjdtfa2g7rl6) and the pre-"latest_css" path, so the sheets 404 in every
    // environment and the printed content rendered unstyled (lost sidebar boxes, figures, and
    // page-number placement). We de-dupe hrefs so we never request the same sheet twice.
    let hrefSet = new Set();
    try {
      let cdnHost =
        (window.Configs && window.Configs.REACT_APP_EPUB_CDN_HOST_URL) || "";
      if (cdnHost) {
        ["epub.css", "epub1.css", "epub2.css", "ap_styles.css"].forEach(
          (file) => {
            hrefSet.add(cdnHost + "casebook/latest_css/" + file + "?v=00001");
          },
        );
      }
    } catch (e) {}
    // Also reuse whatever stylesheets the live page already has (bootstrap, ereader, app CSS,
    // etc.) so the printed output matches the on-screen rendering as closely as possible.
    try {
      document.querySelectorAll('link[rel="stylesheet"]').forEach((lnk) => {
        if (lnk.href) hrefSet.add(lnk.href);
      });
    } catch (e) {}
    let styleLinks = "";
    hrefSet.forEach((href) => {
      styleLinks +=
        '<link href="' +
        href +
        '" rel="stylesheet" type="text/css" charset="utf-8"/>';
    });
    // <link>s only cover externally-hosted sheets. A lot of the app's CSS (App.css, component
    // styles, bootstrap-from-npm, and any runtime CSS-in-JS) lives in inline <style> tags -
    // extracted to files only in a production build - so copy those too, or that styling is
    // missing from the print. Prefer the tag's text; fall back to serializing its CSSOM rules
    // for sheets injected via insertRule (emotion / MUI / styled-components), whose text is empty.
    let styleBlocks = "";
    try {
      document.querySelectorAll("style").forEach((s) => {
        let css = s.innerHTML;
        if (!css && s.sheet && s.sheet.cssRules) {
          try {
            css = Array.from(s.sheet.cssRules)
              .map((rule) => rule.cssText)
              .join("");
          } catch (e) {
            // Cross-origin sheet - cssRules not readable; skip it.
          }
        }
        if (css) styleBlocks += "<style>" + css + "</style>";
      });
    } catch (e) {}
    printWindow.document.write(
      '<!DOCTYPE html><html lang="en"><head><title style="font-size:10px">' +
        cont +
        '</title><meta charset="UTF-8"/><meta http-equiv="Content-Type" content="text/html charset=UTF-8" /><meta http-equiv="X-UA-Compatible" content="IE=edge" /><meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate" /><meta http-equiv="Pragma" content="no-cache" /><meta http-equiv="Expires" content="0"/><meta name="viewport" content="width=device-width, initial-scale=1" />' +
        styleLinks +
        styleBlocks +
        "</head>",
    );
    // NOTE: printing is intentionally NOT triggered from the body's onLoad here.
    // The book's real styling comes from the CloudFront <link> stylesheets above, which
    // load asynchronously; printing on body-load fires before they apply, so the content
    // prints unstyled (lost sidebar boxes, figures, page-number placement). Printing is
    // instead driven from waitForStylesheetsThenPrint() after document.close() below.
    printWindow.document.write('<body class="print-container-read">');
    printWindow.document.write(
      '<div class="waterMarkCont">' + waterMarkCont + "</div>",
    );
    printWindow.document.write(
      '<div class="waterMarkSubCont">' + waterMarkSubCont + "</div>",
    );
    if (browserName == "firefox") {
      printWindow.document.write(
        '<style>.print-container-read #tab-section-container,.print-container-read #note-container{display:block;}.print-container-read #note-container a,.print-container-read #note-container a span,.print-container-read #note-container a div{display:block;}@page:footer{content:"' +
          cont +
          '";}</style>',
      );
    }
    let printMediaCss =
      "@media screen, projection, tv {.waterMarkCont, .waterMarkSubCont {display:none;}}" +
      "@page{size:8.5in 11in;margin:0.5in !important;overflow: visible;}" +
      "@media print{" +
      ".waterMarkCont{display:block;font-size: 44px;  -webkit-transform: rotate(-45deg);  -moz-transform: rotate(-45deg); color:#000; text-transform: uppercase;position: fixed;  width: 100%;  margin: 0;  z-index: 9999; left:0;top:38%;text-align:center;opacity:0.1;}" +
      ".waterMarkSubCont{display:block;font-size: 36px;  -webkit-transform: rotate(-45deg);  -moz-transform: rotate(-45deg); font-family:arial;color:#000; position: fixed;  width: 850px;max-width:850px; word-wrap: break-word;  margin: 0;  z-index: 9999; left:0;top:45%;text-align:center;line-height:45px;opacity:0.1;}" +
      "body{font-family:arial;}" +
      // Force background colours (text highlights, coloured boxes) to print even when the user's
      // Chrome "Background graphics" print option is off - highlights are background-color, which
      // Chrome otherwise strips from the printout, so they go missing.
      "*{-webkit-print-color-adjust:exact !important;print-color-adjust:exact !important;color-adjust:exact !important;}" +
      // page-number markers are meant to sit unobtrusively inline (they carry the printed book's
      // real page number for citation purposes) - without this they fall back to the ereader's
      // on-screen layout rules and land mid-sentence or get scattered across the printed page.
      ".print-container-read .cc-pagenum-begin{position:static !important;display:inline !important;float:none !important;font-size:0.75em;color:#555;white-space:nowrap;margin:0 0.3em;}" +
      // Keep images and boxed/figure/sidebar content from splitting across a page boundary. The
      // on-screen reader sizes media against a wide scrollable panel; at print time cap the width
      // to the page and the height to roughly one page so a tall figure scales down to fit on a
      // single page instead of being cut in half. break-inside is the modern alias of the legacy
      // page-break-inside; both are set so Chrome/Firefox/Safari all honour it.
      ".print-container-read img{max-width:100% !important;height:auto !important;max-height:9in !important;page-break-inside:avoid !important;break-inside:avoid !important;}" +
      ".print-container-read table{max-width:100% !important;page-break-inside:avoid !important;break-inside:avoid !important;}" +
      ".print-container-read figure,.print-container-read .epub-image-container,.print-container-read .epubc-en__text-imageRef,.print-container-read [class*='image' i],.print-container-read [class*='figure' i],.print-container-read [class*='sidebar' i],.print-container-read [class*='aside' i]{page-break-inside:avoid !important;break-inside:avoid !important;}" +
      ".print-container-read [style*='position:absolute'],.print-container-read [style*='position: absolute'],.print-container-read [style*='position:fixed'],.print-container-read [style*='position: fixed']{position:static !important;}" +
      "}";
    printWindow.document.write("<style>" + printMediaCss + "</style>");
    printWindow.document.write(divElements);
    printWindow.document.write("</body></html>");
    if (browserName == "chrome" || browserName == "safari") {
      ereaderScroller.find("#ereader-scroller").css("height", hgt);
      ereaderScroller.find("#ereader-scroller").css("max-height", maxhgt);
    }
    printWindow.document.close();
    waitForStylesheetsThenPrint(printWindow);
  };
  // Fire the print dialog only after the popup's <link> stylesheets (epub/ereader/bootstrap
  // on CloudFront) have actually loaded. Printing before they apply is what strips the book's
  // box, figure, and sidebar styling from the output. A timeout fallback guarantees the print
  // dialog still opens even if a load/error event never arrives, so the user is never stranded.
  const waitForStylesheetsThenPrint = (printWindow) => {
    let hasPrinted = false;
    const doPrint = () => {
      if (hasPrinted || printWindow.closed) return;
      hasPrinted = true;
      try {
        printWindow.focus();
      } catch (e) {}
      try {
        printWindow.print();
      } catch (e) {}
      try {
        printWindow.close();
      } catch (e) {}
    };
    try {
      const linkEls = printWindow.document.querySelectorAll(
        'link[rel="stylesheet"]',
      );
      let pending = 0;
      linkEls.forEach((lnk) => {
        // lnk.sheet stays null until the stylesheet has finished loading.
        if (!lnk.sheet) {
          pending++;
          const onSettled = () => {
            pending--;
            if (pending <= 0) doPrint();
          };
          lnk.addEventListener("load", onSettled);
          lnk.addEventListener("error", onSettled);
        }
      });
      if (pending === 0) {
        doPrint();
      }
    } catch (e) {
      // Cross-origin/access issues: fall through to the timeout below.
    }
    // Safety net: never leave the user without a print dialog if load events don't fire.
    setTimeout(doPrint, 3000);
  };
  const saveUserPrintDetails = () => {
    let printPercentage1;
    if (
      prevPrint !== "0.00" &&
      prevPrint !== "0" &&
      prevPrint !== null &&
      prevPrint !== undefined
    ) {
      printPercentage1 = parseFloat(prevPrint) + parseFloat(currSelection);
    } else {
      printPercentage1 = currSelection;
    }
    let reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "EReader",
          pageNavigatingTo: "EReader",
          lastReadBookId: props.bookVO.bookId,
          lastReadChapterId: "",
          lastReadSubSectionId: "subsec01",
          lastReadParagraphId: "para01",
          lastViewedOutlineId: "",
          lastViewedOutlineType: "chapterOutline",
        },
        sessionVO: {
          appType: "web",
          deviceType: localStorage.getItem("deviceType"),
          deviceOS: localStorage.getItem("deviceOS"),
          deviceMacId: "",
          keepMeLoggedInFlag: keepMeLogIn,
          browserName: localStorage.getItem("browserName"),
          sessionAuthenticationToken: userVO.sessionAuthenticationToken,
        },
      },
      bookVO: {
        bookId: props.bookVO.bookId,
        printedPageList: resultSet,
        printedPercentage: printPercentage1.toString(),
      },
    };
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(reqData),
    };
    fetch(
      localStorage.getItem("ENV") + "/manageBookService/saveUserPrintDetails",
      requestOptions1,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "true") {
          if (data) {
            setPreviousSelectedPage(resultSet);
            setPrevPrint(parseFloat(printPercentage1).toFixed(2));
          }
        } else {
          if (data.wkErrorCode) {
            handleException(data);
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const previewPrintHighlights = () => {
    let highlightCheckBoxStatus = $("#HighLights")[0].checked;
    if (highlightCheckBoxStatus === false) {
      setHighLightChecked(!highLightChecked);
      printHighlightChecked = false;
      let printHighLightTags = $("highlight");
      loadPrintModalAfterResize();
    } else if (highlightCheckBoxStatus === true) {
      setHighLightChecked(!highLightChecked);
      printHighlightChecked = true;
      let printHighLightTags = $("#print-ereader-scroller highlight");
      for (let i = 0; i < printHighLightTags.length; i++) {
        for (let j = 0; j < relatedHighLightTags.length; j++) {
          if (printHighLightTags[i].id.indexOf("_") !== -1) {
            let conAnnId = printHighLightTags[i].id.split("_")[0];
            if (relatedHighLightTags[j].id === conAnnId) {
              let highlightSpanTag1 = $(
                "#print-ereader-scroller highlight#" + printHighLightTags[i].id,
              );
              highlightSpanTag1.attr(
                "style",
                "background-color:" +
                  relatedHighLightTags[j].style.backgroundColor +
                  "!important",
              );
            }
          } else if (relatedHighLightTags[j].id === printHighLightTags[i].id) {
            let highlightSpanTag1 = $(
              "#print-ereader-scroller highlight#" + printHighLightTags[i].id,
            );
            highlightSpanTag1.attr(
              "style",
              "background-color:" +
                relatedHighLightTags[j].style.backgroundColor +
                "!important",
            );
          }
        }
      }
      let printBriefTags = $("#print-ereader-scroller briefsTag");
      for (let i = 0; i < printBriefTags.length; i++) {
        for (let j = 0; j < relatedBriefTags.length; j++) {
          if (printBriefTags[i].id.indexOf("_") !== -1) {
            let conAnnId = printBriefTags[i].id.split("_")[0];
            if (relatedBriefTags[j].id === conAnnId) {
              let briefSpanTag1 = $(
                "#print-ereader-scroller briefsTag#" + printBriefTags[i].id,
              );
              briefSpanTag1.attr(
                "style",
                "background-color:" +
                  relatedBriefTags[j].style.backgroundColor +
                  "!important",
              );
            }
          } else if (relatedBriefTags[j].id === printBriefTags[i].id) {
            let briefSpanTag1 = $(
              "#print-ereader-scroller briefsTag#" + relatedBriefTags[i].id,
            );
            briefSpanTag1.attr(
              "style",
              "background-color:" +
                relatedBriefTags[j].style.backgroundColor +
                "!important",
            );
          }
        }
      }
      loadPrintModalAfterResize();
    }
    $("#print-tab-section-container #links-container").remove();
  };
  const loadPrintModalAfterResize = () => {
    $("#print-ereader-scroller #print-tab-section-container").click(false);
    $("#print-ereader-scroller #notes-container").click(false);
    $("#print-ereader-scroller #notes-container a").removeAttr("onclick");
    $(".notesText").removeClass("hidden-xs");
    $(".labelNoteWrapper").removeClass("hidden-xs");
    $(".labelText").removeClass("hidden-xs");
    $(".briefNotesText").removeClass("hidden-xs");
    $("input#print_notes_margin").prop("checked", "true");
    $("input#print_highlights").prop("checked", "true");
    $(".print-fs button").css("border", "none");
    if (!printNoteChecked) {
      $("#print-ereader-scroller #notes-container").hide();
      $("#print-ereader-scroller #tab-section-container").css("width", "95%");
    }
    if (!printHighlightChecked) {
      printHighlightChecked = false;
      let printHighLightTags = $("#print-ereader-scroller .highlightedText");
      for (let i = 0; i < printHighLightTags.length; i++) {
        let highlightSpanTag = $(
          "#print-ereader-scroller highlight#" + printHighLightTags[i].id,
        );
        highlightSpanTag.removeAttr("style");
        highlightSpanTag.attr("style", "background-color:#ffffff");
      }
      let printBriefTags = $("#print-ereader-scroller .briefElementText");
      for (let i = 0; i < printBriefTags.length; i++) {
        let briefSpanTag = $(
          "#print-ereader-scroller briefsTag#" + printBriefTags[i].id,
        );
        briefSpanTag.removeAttr("style");
        briefSpanTag.attr("style", "background-color:#ffffff");
      }
    }
    $("#print-tab-section-container #links-container").remove();
    $("#print-tab-section-container #print-ereader-scroller anchortag").css(
      "color",
      "#000!important",
    );
  };
  const previewPrintNotes = () => {
    let noteCheckBoxStatus = $("#IncludeChapter")[0].checked;
    if (noteCheckBoxStatus === false) {
      setNoteChecked(!noteChecked);
      printNoteChecked = false;
    } else if (noteCheckBoxStatus === true) {
      setNoteChecked(!noteChecked);
      printNoteChecked = true;
    }
    $("#print-tab-section-container #links-container").remove();
  };
  const selectAllfunc = () => {
    sectionList.forEach((sec) => {
      setCheckedItems((prevState) => ({ ...prevState, [sec.name]: false }));
    });
    noPrintSectionList = [];
    let sectionItems = $("#chapter-section-list").children();
    sectionList.map((sec1, key) => {
      let secType = sec1.type;
      if (secType.toString() === "-999") {
        secType = "C";
      }
      if (secType == "A" || secType == "B" || secType == "intro-section") {
        let id = sec1.id;
        if (id == "epub-localToc") {
          $("#print-tab-section-container ." + id).show();
          $("#print-tab-section-container .cc-localToc").show();
        } else if (secType === "intro-section") {
          if (
            $("#print-content-modal #" + id).find(".cc-section-title")[0] ===
              undefined &&
            $("#print-content-modal #" + id).find(
              ".cc-principalCase-title",
            )[0] === undefined
          ) {
            $("#print-tab-section-container #" + id)
              .children()
              .show();
          } else {
            $("#print-tab-section-container #" + id)
              .children()
              .not(".cc-section")
              .show();
          }
        } else {
          $("#print-tab-section-container #" + id)
            .children()
            .not(".cc-section")
            .show();
          let sec = $("#print-tab-section-container #" + id)
            .children()
            .not(".cc-section");
          let idLt, clName;
          for (let i = 0; i < sec.length; i++) {
            idLt = sec[i].id;
            if (idLt == "") {
              let list = [],
                idhEle = "",
                idbEle = "";
              $(sec[i]).each(function () {
                $(this)
                  .find("highlight")
                  .each(function () {
                    idhEle = $(this).attr("id");
                    list.push(idhEle);
                  });
                $(this)
                  .find("briefstag")
                  .each(function () {
                    idbEle = $(this).attr("id");
                    list.push(idbEle);
                  });
              });
              if (list.length > 0) {
                showNotesMargin(list);
              }
            } else {
              let idLst = getHighlightOrBriefIds(idLt);
              if (idLst.length > 0) {
                showNotesMargin(idLst);
              }
            }
            if ($(sec[i].childNodes).hasClass("cc-principal-case")) {
              $(sec[i]).show();
              $(sec[i].childNodes).not(".cc-section").show();
            }
          }
        }
      }
      if (secType == "pCase" || secType == "C") {
        let id = sec1.id;
        $("#print-tab-section-container #" + id).show();
        let idList = getHighlightOrBriefIds(id);
        if (idList.length > 0) {
          showNotesMargin(idList);
        }
        if (
          !$("#print-tab-section-container #" + id)
            .parent()
            .hasClass("cc-section")
        ) {
          $("#print-tab-section-container #" + id)
            .parent()
            .show();
          let disp = $("#print-tab-section-container #" + id)
            .parent()
            .css("display");
          if (disp == "hide") {
            $("#print-tab-section-container #" + id)
              .parent()
              .children()
              .not(".cc-section")
              .hide();
          }
        }
      }
      return sec1;
    });
    if (!printNoteChecked) {
      $("#print-ereader-scroller #notes-container").hide();
      $("#print-ereader-scroller #tab-section-container").css("width", "95%");
    }
    if (!printHighlightChecked) {
      let printHighLightTags = $("#print-ereader-scroller .highlightedText");
      for (let i = 0; i < printHighLightTags.length; i++) {
        let highlightSpanTag = $(
          "#print-ereader-scroller highlight#" + printHighLightTags[i].id,
        );
        highlightSpanTag.removeAttr("style");
        highlightSpanTag.attr("style", "background-color:#ffffff");
      }
      let printBriefTags = $("#print-ereader-scroller .briefElementText");
      for (let i = 0; i < printBriefTags.length; i++) {
        let briefSpanTag = $(
          "#print-ereader-scroller briefsTag#" + printBriefTags[i].id,
        );
        briefSpanTag.removeAttr("style");
        briefSpanTag.attr("style", "background-color:#ffffff");
      }
    }
    if ($("input.page-sec:checked").length != 0) {
      $(
        "#print-ereader-scroller #print-tab-section-container .ereader-content",
      ).removeAttr("style");
    }
    setBtnDisabled(true);
    calcPrint();
  };
  const deselectAllfunc = () => {
    sectionList.forEach((sec) => {
      setCheckedItems((prevState) => ({ ...prevState, [sec.name]: true }));
    });
    let printList = [],
      pageSecList = [];
    let sectionItems = $("#chapter-section-list").children();
    sectionList.map((item5, index5) => {
      let secType = item5.type;
      if (secType.toString() === "-999") {
        secType = "C";
      }
      if (secType == "A" || secType == "B" || secType == "intro-section") {
        let id = item5.id;
        if (id == "epub-localToc") {
          $("#print-tab-section-container ." + id).hide();
          $("#print-tab-section-container .cc-localToc").hide();
          printList.push(id);
        } else if (secType === "intro-section") {
          if (
            $("#print-content-modal #" + id).find(".cc-section-title")[0] ===
              undefined &&
            $("#print-content-modal #" + id).find(
              ".cc-principalCase-title",
            )[0] === undefined
          ) {
            $("#print-tab-section-container #" + id)
              .children()
              .hide();
          } else {
            $("#print-tab-section-container #" + id)
              .children()
              .not(".cc-section")
              .hide();
          }
          printList.push(id);
        } else {
          $("#print-tab-section-container #" + id)
            .children()
            .not(".cc-section")
            .hide();
          let sec = $("#print-tab-section-container #" + id)
            .children()
            .not(".cc-section");
          printList.push(id);
          let idLt, clName;
          for (let i = 0; i < sec.length; i++) {
            idLt = sec[i].id;
            if (idLt == "") {
              let list = [],
                idhEle = "",
                idbEle = "";
              $(sec[i]).each(function () {
                $(this)
                  .find("highlight")
                  .each(function () {
                    idhEle = $(this).attr("id");
                    list.push(idhEle);
                  });
                $(this)
                  .find("briefstag")
                  .each(function () {
                    idbEle = $(this).attr("id");
                    list.push(idbEle);
                  });
              });
              if (list.length > 0) {
                hideNotesMargin(list);
              }
            } else {
              let idLst = getHighlightOrBriefIds(idLt);
              if (idLst.length > 0) {
                hideNotesMargin(idLst);
              }
            }
            if ($(sec[i].childNodes).hasClass("cc-principal-case")) {
              $(sec[i]).hide();
              $(sec[i].childNodes).not(".cc-section").hide();
              $(sec[i].childNodes).each(function () {
                if ($(this)[0].className != undefined) {
                  if ($(this)[0].className.indexOf("cc-section") != -1) {
                    let idList = getHighlightOrBriefIds($(this)[0].id);
                    if (idList.length > 0) {
                      hideNotesMargin(idList);
                    }
                  }
                }
              });
            }
          }
        }
      }
      if (secType == "pCase" || secType == "C") {
        let id = item5.id;
        $("#print-tab-section-container #" + id).hide();
        let idList = getHighlightOrBriefIds(id);
        if (idList.length > 0) {
          hideNotesMargin(idList);
        }
        if (
          !$("#print-tab-section-container #" + id)
            .parent()
            .hasClass("cc-section")
        ) {
          let disp = $("#print-tab-section-container #" + id)
            .parent()
            .css("display");
          if (disp == "hide") {
            $("#print-tab-section-container #" + id)
              .parent()
              .hide();
            $("#print-tab-section-container #" + id)
              .parent()
              .children()
              .not(".cc-section")
              .hide();
          }
        }
        printList.push(id);
      }
      return item5;
    });
    noPrintSectionList = printList;
    for (let i = 0; i < printList.length; i++) {
      $("#chapter-section-list")
        .find("[data-id='" + printList[i] + "'] input")
        .prop("checked", false);
    }
    if ($("input.page-sec:checked").length == 0) {
      $(
        "#print-tab-section-container #print-ereader-scroller .ereader-content",
      ).css("width", "100%");
    }
    setBtnDisabled(false);
    calcPrint();
  };
  // Sizes above 20 scale every tier off the base value using the same offsets the "20" block
  // uses relative to its own base (20 -> xxsmall -2, xsmall +2, small +4, medium/large/notes +10,
  // xlarge +16, chapter-title +22). The 12-20 tiers below are hand-tuned pixel values that don't
  // follow a consistent formula, so they're left as-is; this only covers the new, larger sizes.
  const applyLargePrintFontSize = (base) => {
    let contentClass = "#print-tab-section-container",
      j = "1.2";
    $(".ccapp-chunkHeader").css({ "font-size": "200%", "line-height": "120%" });
    [
      " div:not([cc-font-xxsmall]) p",
      " div:not([cc-font-xsmall]) p",
      " div:not([cc-font-small]) p",
      " div:not([cc-font-medium]) p",
      " div:not([cc-font-large]) p",
      " div:not([cc-font-xlarge]) p",
    ].forEach((selector) => {
      $(contentClass + selector).css({
        "font-size": base + "px",
        "line-height": j,
      });
    });
    $(contentClass)
      .find(".cc-font-xxsmall p")
      .css("font-size", base - 2 + "px");
    $(contentClass)
      .find(".cc-font-xsmall p")
      .css("font-size", base + 2 + "px");
    $(contentClass)
      .find(".cc-font-xsmall")
      .css("font-size", base + 2 + "px");
    $(contentClass)
      .find(".cc-font-small p")
      .css("font-size", base + 4 + "px");
    $(contentClass)
      .find(".cc-font-small")
      .css("font-size", base + 4 + "px");
    $(contentClass).find("#notes-container .notesText").css({
      "font-size": base + 10 + "px",
      "line-height": j,
    });
    $(contentClass).find("#notes-container .labelNoteWrapper").css({
      "font-size": base + 10 + "px",
      "line-height": j,
    });
    $(contentClass).find(".cc-font-medium h3 p").css({
      "font-size": base + 10 + "px",
      "line-height": j,
    });
    $(contentClass).find(".cc-font-medium").css({
      "font-size": base + 10 + "px",
      "line-height": j,
    });
    $(contentClass).find(".cc-font-large p").css({
      "font-size": base + 10 + "px",
      "line-height": j,
    });
    $(contentClass).find(".cc-font-large").css({
      "font-size": base + 10 + "px",
      "line-height": j,
    });
    $(contentClass).find(".cc-font-xlarge").css({
      "font-size": base + 16 + "px",
      "line-height": j,
    });
    $(contentClass).find(".cc-font-xlarge h2 p").css({
      "font-size": base + 16 + "px",
      "line-height": j,
    });
    $(contentClass).find(".cc-font-xlarge h3 p").css({
      "font-size": base + 16 + "px",
      "line-height": j,
    });
    $(contentClass).find(".cc-chapter-title h1 p").css({
      "font-size": base + 22 + "px",
      "line-height": j,
    });
    $(contentClass).find(".cc-chapter-title").css({
      "font-size": base + 22 + "px",
      "line-height": j,
    });
  };
  const handleFontSizePrint = (e) => {
    setFontSizePrint(e.target.value);
    let contentClass = "#print-tab-section-container",
      i,
      j;
    j = "1.2";
    if (e.target.value === "12") {
      $(".ccapp-chunkHeader").css({
        "font-size": "200%",
        "line-height": "120%",
      });
      $(contentClass + " div:not([cc-font-xxsmall]) p").css({
        "font-size": "12px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-xsmall]) p").css({
        "font-size": "12px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-small]) p").css({
        "font-size": "12px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-medium]) p").css({
        "font-size": "12px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-large]) p").css({
        "font-size": "12px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-xlarge]) p").css({
        "font-size": "12px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xxsmall p").css("font-size", "11px");
      $(contentClass).find(".cc-font-xsmall p").css("font-size", "12px");
      $(contentClass).find(".cc-font-xsmall").css("font-size", "12px");
      $(contentClass).find(".cc-font-small p").css("font-size", "14px");
      $(contentClass).find(".cc-font-small").css("font-size", "14px");
      $(contentClass).find("#notes-container .notesText").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass).find("#notes-container .labelNoteWrapper").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-medium h3 p").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-medium").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-large p").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-large").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge h2 p").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge h3 p").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass).find(".cc-chapter-title h1 p").css({
        "font-size": "22px",
        "line-height": j,
      });
      $(contentClass).find(".cc-chapter-title").css({
        "font-size": "22px",
        "line-height": j,
      });
    } else if (e.target.value === "14") {
      $(".ccapp-chunkHeader").css({
        "font-size": "200%",
        "line-height": "120%",
      });
      $(contentClass + " div:not([cc-font-xxsmall]) p").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-xsmall]) p").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-small]) p").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-medium]) p").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-large]) p").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-xlarge]) p").css({
        "font-size": "14px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xxsmall p").css("font-size", "12px");
      $(contentClass).find(".cc-font-xsmall p").css("font-size", "14px");
      $(contentClass).find(".cc-font-xsmall").css("font-size", "14px");
      $(contentClass).find(".cc-font-small p").css("font-size", "16px");
      $(contentClass).find(".cc-font-small").css("font-size", "16px");
      $(contentClass).find("#notes-container .notesText").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass).find("#notes-container .labelNoteWrapper").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-medium h3 p").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-medium").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-large p").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-large").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge").css({
        "font-size": "18px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge h2 p").css({
        "font-size": "18px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge h3 p").css({
        "font-size": "18px",
        "line-height": j,
      });
      $(contentClass).find(".cc-chapter-title h1 p").css({
        "font-size": "24px",
        "line-height": j,
      });
      $(contentClass).find(".cc-chapter-title").css({
        "font-size": "24px",
        "line-height": j,
      });
    } else if (e.target.value === "16") {
      $(".ccapp-chunkHeader").css({
        "font-size": "200%",
        "line-height": "120%",
      });
      $(contentClass + " div:not([cc-font-xxsmall]) p").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-xsmall]) p").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-small]) p").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-medium]) p").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-large]) p").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-xlarge]) p").css({
        "font-size": "16px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xxsmall p").css("font-size", "14px");
      $(contentClass).find(".cc-font-xsmall p").css("font-size", "16px");
      $(contentClass).find(".cc-font-xsmall").css("font-size", "16px");
      $(contentClass).find(".cc-font-small p").css("font-size", "18px");
      $(contentClass).find(".cc-font-small").css("font-size", "18px");
      $(contentClass).find("#notes-container .notesText").css({
        "font-size": "22px",
        "line-height": j,
      });
      $(contentClass).find("#notes-container .labelNoteWrapper").css({
        "font-size": "22px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-medium h3 p").css({
        "font-size": "22px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-medium").css({
        "font-size": "22px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-large p").css({
        "font-size": "22px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-large").css({
        "font-size": "22px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge").css({
        "font-size": "24px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge h2 p").css({
        "font-size": "24px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge h3 p").css({
        "font-size": "24px",
        "line-height": j,
      });
      $(contentClass).find(".cc-chapter-title h1 p").css({
        "font-size": "30px",
        "line-height": j,
      });
      $(contentClass).find(".cc-chapter-title").css({
        "font-size": "30px",
        "line-height": j,
      });
    } else if (e.target.value === "18") {
      $(".ccapp-chunkHeader").css({
        "font-size": "200%",
        "line-height": "120%",
      });
      $(contentClass + " div:not([cc-font-xxsmall]) p").css({
        "font-size": "18px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-xsmall]) p").css({
        "font-size": "18px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-small]) p").css({
        "font-size": "18px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-medium]) p").css({
        "font-size": "18px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-large]) p").css({
        "font-size": "18px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-xlarge]) p").css({
        "font-size": "18px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xxsmall p").css("font-size", "16px");
      $(contentClass).find(".cc-font-xsmall p").css("font-size", "18px");
      $(contentClass).find(".cc-font-xsmall").css("font-size", "18px");
      $(contentClass).find(".cc-font-small p").css("font-size", "22px");
      $(contentClass).find(".cc-font-small").css("font-size", "22px");
      $(contentClass).find("#notes-container .notesText").css({
        "font-size": "24px",
        "line-height": j,
      });
      $(contentClass).find("#notes-container .labelNoteWrapper").css({
        "font-size": "24px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-medium h3 p").css({
        "font-size": "24px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-medium").css({
        "font-size": "24px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-large p").css({
        "font-size": "24px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-large").css({
        "font-size": "24px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge").css({
        "font-size": "30px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge h2 p").css({
        "font-size": "30px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge h3 p").css({
        "font-size": "30px",
        "line-height": j,
      });
      $(contentClass).find(".cc-chapter-title h1 p").css({
        "font-size": "36px",
        "line-height": j,
      });
      $(contentClass).find(".cc-chapter-title").css({
        "font-size": "36px",
        "line-height": j,
      });
    } else if (e.target.value === "20") {
      $(".ccapp-chunkHeader").css({
        "font-size": "200%",
        "line-height": "120%",
      });
      $(contentClass + " div:not([cc-font-xxsmall]) p").css({
        "font-size": "20px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-xsmall]) p").css({
        "font-size": "20px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-small]) p").css({
        "font-size": "20px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-medium]) p").css({
        "font-size": "20px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-large]) p").css({
        "font-size": "20px",
        "line-height": j,
      });
      $(contentClass + " div:not([cc-font-xlarge]) p").css({
        "font-size": "20px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xxsmall p").css("font-size", "18px");
      $(contentClass).find(".cc-font-xsmall p").css("font-size", "22px");
      $(contentClass).find(".cc-font-xsmall").css("font-size", "22px");
      $(contentClass).find(".cc-font-small p").css("font-size", "24px");
      $(contentClass).find(".cc-font-small").css("font-size", "24px");
      $(contentClass).find("#notes-container .notesText").css({
        "font-size": "30px",
        "line-height": j,
      });
      $(contentClass).find("#notes-container .labelNoteWrapper").css({
        "font-size": "30px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-medium h3 p").css({
        "font-size": "30px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-medium").css({
        "font-size": "30px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-large p").css({
        "font-size": "30px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-large").css({
        "font-size": "30px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge").css({
        "font-size": "36px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge h2 p").css({
        "font-size": "36px",
        "line-height": j,
      });
      $(contentClass).find(".cc-font-xlarge h3 p").css({
        "font-size": "36px",
        "line-height": j,
      });
      $(contentClass).find(".cc-chapter-title h1 p").css({
        "font-size": "42px",
        "line-height": j,
      });
      $(contentClass).find(".cc-chapter-title").css({
        "font-size": "42px",
        "line-height": j,
      });
    } else if (parseInt(e.target.value, 10) > 20) {
      applyLargePrintFontSize(parseInt(e.target.value, 10));
    }
  };
  const spinnerLabel = () => {
    let label = "";
    if (printPageLoading) {
      label = "Loading eBook details";
    } else if (outlineLoading) {
      label = "Loading chapter outlines";
    } else if (casebriefLoading) {
      label = "Loading case brief";
    } else if (notepadLoading) {
      label = "Loading Notepad";
    }
    return label;
  };
  function handlePrintModal(e) {
    if (e.key === "Enter") {
      showPrintModal();
    }
  }
  function handleExportOutlines(e) {
    if (e.key === "Enter") {
      setIsOutlineModalOpen(true);
    }
  }
  function handleExportCaseBriefs(e) {
    if (e.key === "Enter") {
      setIsBriefModalOpen(true);
    }
  }
  function handleExportNotepad(e) {
    if (e.key === "Enter") {
      getLatestNotesDrpdwn();
    }
  }
  function handleHighLightCheckbox(e) {
    if (e.key === "Enter") {
      document.getElementById("HighLights").click();
    }
  }
  function handleChapterCheckbox(e) {
    if (e.key === "Enter") {
      document.getElementById("IncludeChapter").click();
    }
  }
  function handleSelect(e, id) {
    if (e.key === "Enter") {
      id === "selectAll" ? selectAllfunc() : deselectAllfunc();
    }
  }
  function handleSectionCheckbox(e, id) {
    if (e.key === "Enter") {
      document.getElementById(id).click();
    }
  }
  const hidePrintModal = (e) => {
    setIsPrintModalOpen(false);
    setTimeout(() => {
      document.getElementById("collasible-export-dropdown").focus();
    }, 200);
  };
  const hideExportOutLineModal = () => {
    setIsOutlineModalOpen(false);
    setTimeout(() => {
      document.getElementById("collasible-export-dropdown").focus();
    }, 200);
  };
  const hideExportCaseBriefsModal = () => {
    setIsBriefModalOpen(false);
    setTimeout(() => {
      document.getElementById("collasible-export-dropdown").focus();
    }, 200);
  };
  const hideExportNotepadModal = () => {
    setIsNoteModalOpen(false);
    setTimeout(() => {
      document.getElementById("collasible-export-dropdown").focus();
    }, 200);
  };
  return (
    <React.Fragment>
      <NavDropdownMenu
        title="Export"
        aria-label="Export"
        id="collasible-export-dropdown"
      >
        <div className="navBarSettingBlock">
          <span
            data-testid="printEbook"
            onKeyDown={(e) => handlePrintModal(e)}
            id="print-ebook-page-submenu"
          >
            <DropdownSubmenu
              href=""
              data-toggle="modal"
              aria-label="Print E-Book Pages"
              title={
                <span data-testid="print" onClick={() => showPrintModal()}>
                  Print E-Book Pages
                </span>
              }
            />
          </span>
          <span
            data-testid="export-outline"
            onKeyDown={(e) => handleExportOutlines(e)}
            id="export-outline-page-submenu"
          >
            <DropdownSubmenu
              href=""
              aria-label="Export Outlines"
              title={
                <span
                  data-testid="exportOutlines"
                  onClick={() => setIsOutlineModalOpen(true)}
                >
                  Export Outlines
                </span>
              }
            />
          </span>
          {props.bookVO.casesFlag === "true" ? (
            <span
              data-testid="export-caseBriefs"
              onKeyDown={(e) => handleExportCaseBriefs(e)}
              id="export-casebriefs-page-submenu"
            >
              <DropdownSubmenu
                href=""
                aria-label="Export Case Briefs"
                title={
                  <span
                    data-testid="exportCaseBriefs"
                    onClick={() => setIsBriefModalOpen(true)}
                  >
                    Export Case Briefs
                  </span>
                }
              />
            </span>
          ) : null}
          <span
            data-testid="export-notepad"
            onKeyDown={(e) => handleExportNotepad(e)}
            id="export-notepad-page-submenu"
          >
            <DropdownSubmenu
              href=""
              aria-label="Export Notepad"
              title={
                <span
                  data-testid="exportNotepad"
                  onClick={() => getLatestNotesDrpdwn()}
                >
                  Export Notepad
                </span>
              }
            />
          </span>
        </div>
      </NavDropdownMenu>
      <Modal
        className="modal fade"
        show={isOutlineModalOpen}
        onHide={hideExportOutLineModal}
        id="exportModalId"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="export outline"
      >
        <div className="modal-header">
          <h5 className="modal-title" id="outlinemodal">
            Export Outlines
          </h5>
          <button
            data-testid="close_export_modal"
            className="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close Dialog"
            onClick={() => hideExportOutLineModal()}
          >
            <span
              aria-hidden="true"
              aria-label="Close Dialog"
              className="modal_button"
            >
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body exportModalIdlabel" aria-hidden="true">
          Select an outline to export as a Microsoft Word document. Your export
          may take a couple minutes to download.
        </div>
        <select
          data-testid="exportChpaterListDrpDwn"
          id="exportChpaterListDrpDwn"
          value={currentChapterId}
          className="viewingExport mLeftFive form-control text-box-common display-inline-block"
          onChange={(e) => onChangeChapterEvent(e)}
          aria-label="Loading chapter outlines"
        >
          {exportChapterDrpDwnList !== undefined
            ? exportChapterDrpDwnList.map((option, index) => (
                <option key={index} value={option.chapterId}>
                  {option.navbarTitle}
                </option>
              ))
            : ""}
        </select>
        <div className="modal-footer">
          <button
            data-testid="exportOutline"
            type="button"
            className="btn btn-primary"
            onClick={(e) => getLatestOutline(e)}
          >
            Export Outline
          </button>
        </div>
        <div
          className="ExportOutline"
          id="ExportOutline"
          style={{ display: "none" }}
        >
          <span className="export-case-name">{currrentChapterName}</span>
          {sectionVOList &&
            sectionVOList.map((item, i) => (
              <div
                key={i}
                sectionId={item.sectionId}
                id={"outlineSection_" + item.sectionId}
                className={
                  item.sectionType === "A" || item.sectionType === "-9999"
                    ? "mTopTen"
                    : "mLeftThirty mTopTen"
                }
              >
                {item.sectionTitle !== "-9999" ? item.sectionTitle : ""}
                {item.annotationVOList !== undefined
                  ? item.annotationVOList.map((annotation, index) => {
                      if (annotation.dppContentType === "annotation") {
                        return (
                          <div
                            key={index}
                            annotationId={annotation.annotationId}
                            id={"outline_" + annotation.annotationId}
                            Ccode={annotation.highlightColorCode}
                            className="annotatedOutlineCont"
                            noteFlag={
                              annotation.noteText !== undefined
                                ? "true"
                                : "false"
                            }
                            style={{
                              backgroundColor: annotation.highlightColorCode,
                              textDecoration:
                                annotation.highlightColorCode.toLowerCase() ==
                                "underline"
                                  ? "underline"
                                  : "",
                            }}
                          >
                            {annotation.highlightText}
                            {annotation.noteText !== undefined ? (
                              <div
                                className="outline_noteText"
                                style={{ borderTop: "1px solid #000000" }}
                              >
                                {" "}
                                {annotation.noteText}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        );
                      } else if (annotation.dppContentType === "brief") {
                        return (
                          <div
                            key={index}
                            annotationId={annotation.annotationId}
                            id={"outline_" + annotation.annotationId}
                            Ccode={annotation.highlightColorCode}
                            className="annotatedOutlineCont"
                            noteFlag={
                              annotation.noteText !== undefined
                                ? "true"
                                : "false"
                            }
                            style={{
                              backgroundColor: annotation.highlightColorCode,
                              textDecoration:
                                annotation.highlightColorCode.toLowerCase() ==
                                "underline"
                                  ? "underline"
                                  : "",
                            }}
                          >
                            {annotation.highlightText}
                            {annotation.noteText !== undefined ? (
                              <div
                                className="outline_noteText"
                                style={{ borderTop: "1px solid #000000" }}
                              >
                                {" "}
                                {annotation.noteText}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        );
                      } else if (annotation.dppContentType === "link") {
                        return (
                          <div
                            key={index}
                            annotationId={annotation.annotationId}
                            id={"outline_" + annotation.annotationId}
                            linkShareFlag={annotation.linkShareFlag}
                            Cclink={annotation.linkUrl}
                            className="annotatedOutlineCont"
                          >
                            <div className="annotationLink">
                              <span className="profLinkUrl">
                                {annotation.linkUrl}
                              </span>
                            </div>
                          </div>
                        );
                      }
                    })
                  : ""}
              </div>
            ))}
        </div>
      </Modal>
      <Modal
        className="modal fade "
        show={isBriefModalOpen}
        onHide={hideExportCaseBriefsModal}
        id="exportModalbrief"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="export outline"
      >
        <div className="modal-header">
          <h5 className="modal-title " id="exportModalbriefid">
            Export Case Briefs
          </h5>
          <button
            data-testid="close_case_brief_modal"
            className="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close Dialog"
            onClick={() => hideExportCaseBriefsModal()}
          >
            <span
              aria-hidden="true"
              aria-label="Close Dialog"
              className="modal_button"
            >
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body" aria-hidden="true">
          Select a case brief to export as a Microsoft Word document. Your
          export may take a couple minutes to download.
        </div>
        <select
          data-testid="exportBriefListDrpDwn"
          id="exportBriefListDrpDwn"
          className="viewingExport mLeftFive form-control text-box-common display-inline-block"
          value={pCaseSectionId}
          onChange={(e) => onChangeBriefEvent(e)}
          aria-label="Loading case brief"
        >
          {exportBriefDrpDwnList &&
            exportBriefDrpDwnList.map(
              ({ navbarTitle, chapterId, sectionVOList }, key) => (
                <optgroup label={navbarTitle.split(":")[0]} key={key}>
                  {sectionVOList !== undefined &&
                    sectionVOList.map(
                      ({ sectionId, sectionCitation, sectionTitle }, i) => (
                        <option
                          data-testid={`option_${sectionId}`}
                          key={i}
                          value={sectionId}
                          sectionCitation={sectionCitation}
                          chapterId={chapterId}
                        >
                          {sectionTitle}
                        </option>
                      ),
                    )}
                </optgroup>
              ),
            )}
        </select>
        <div className="modal-footer">
          <button
            data-testid="exportBrief"
            type="button"
            className="btn btn-primary"
            onClick={(e) => getLatestBrief(e)}
          >
            Export Brief
          </button>
        </div>
        <div id="briefNotesExport" style={{ display: "none" }}>
          <span className="export-case-name">{pCaseNavTitle}</span>
          <ul
            className="labelVOList "
            style={{ listStyleType: "none", padding: "0" }}
          >
            {labelVOList
              ? labelVOList.map((label, index) =>
                  label.colorCode !== undefined &&
                  label.colorCode.length > 0 ? (
                    <li key={index}>
                      <div
                        className="colorEditorContainer_cb mTopTen"
                        id={(label.labelName + label.colorCode).replace(
                          "#",
                          "Id",
                        )}
                      >
                        <div
                          className="colorEditorTop_cb"
                          style={{ backgroundColor: label.colorCode }}
                        >
                          <div className="colorLabelContainer">
                            <div
                              className="display-inline-block colorLabelBlock"
                              style={{ padding: "6px 10px" }}
                            >
                              <span
                                className="colorLabelName"
                                style={{ verticalAlign: "text-top" }}
                              >
                                {label.labelName}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="BriefPlate">
                          {label.briefVOList !== undefined ? (
                            label.briefVOList !== undefined ? (
                              Array.isArray(label.briefVOList) ? (
                                label.briefVOList.map((brief, i) => (
                                  <div
                                    key={i}
                                    id={"case_" + brief.annotationId}
                                    annotationId={brief.annotationId}
                                    className="annotatedOutlineCont"
                                    style={{
                                      backgroundColor: label.colorCode,
                                      color: "#000",
                                    }}
                                  >
                                    {brief.highlightText}
                                    {brief.noteText !== undefined ? (
                                      <div
                                        style={{
                                          borderTop: "1px solid #000000",
                                        }}
                                      >
                                        {" "}
                                        {brief.noteText}
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                ))
                              ) : (
                                <div
                                  id={"case_" + label.briefVOList.annotationId}
                                  annotationId={label.briefVOList.annotationId}
                                  className="annotatedOutlineCont"
                                  style={{
                                    backgroundColor: label.colorCode,
                                    color: "#000",
                                  }}
                                >
                                  {" "}
                                  {label.briefVOList.highlightText}
                                  {label.briefVOList.noteText !== undefined ? (
                                    <div
                                      style={{ borderTop: "1px solid #000000" }}
                                    >
                                      {" "}
                                      {label.briefVOList.noteText}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              )
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="CustomNote">
                          {label.customBriefVOList !== undefined ? (
                            label.customBriefVOList !== undefined ? (
                              Array.isArray(label.customBriefVOList) ? (
                                label.customBriefVOList.map((custom, i) => (
                                  <div
                                    key={i}
                                    id={"case_" + custom.annotationId}
                                    annotationId={custom.annotationId}
                                    className="annotatedOutlineCont"
                                    style={{ color: "#000" }}
                                  >
                                    {custom.customNoteText}
                                  </div>
                                ))
                              ) : label.customBriefVOList.annotationId !==
                                  undefined &&
                                label.customBriefVOList !== undefined ? (
                                <div
                                  id={
                                    "case_" +
                                    label.customBriefVOList.annotationId
                                  }
                                  annotationId={
                                    label.customBriefVOList.annotationId
                                  }
                                  className="annotatedOutlineHighlightCont"
                                  style={{ color: "#000" }}
                                >
                                  {label.customBriefVOList.customNoteText ? (
                                    <div
                                      style={{
                                        fontStyle: "italic",
                                        marginTop: "10px",
                                        padding: "10px 10px 0px",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          label.customBriefVOList
                                            .customNoteText,
                                      }}
                                    ></div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ) : null
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </li>
                  ) : null,
                )
              : ""}
          </ul>
        </div>
      </Modal>
      <Modal
        className="modal fade "
        show={isNoteModalOpen}
        onHide={hideExportNotepadModal}
        id="exportModalnote"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="export outline"
      >
        <div className="modal-header">
          <h5 className="modal-title" id="exportModalnoteid">
            Export Notepad
          </h5>
          <button
            data-testid="close_export_notepad"
            className="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close Dialog"
            onClick={() => hideExportNotepadModal()}
          >
            <span
              aria-hidden="true"
              aria-label="Close Dialog"
              className="modal_button"
            >
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body" aria-hidden="true">
          Select a note to export as a Microsoft Word document. Your export may
          take a couple minutes to download.
        </div>
        <select
          data-testid="exportNotesListDrpDwn"
          id="exportNotesListDrpDwn"
          className="viewingExport mLeftFive form-control text-box-common display-inline-block"
          onChange={(e) => onChangeNotesEvent(e)}
          aria-label="Loading Notepad"
        >
          {exportNotes !== undefined
            ? exportNotes.map((option, i) => (
                <option
                  data-testid={`option_${chapterId}`}
                  key={i}
                  value={option.chapterId}
                >
                  {option.chapterTitle}
                </option>
              ))
            : ""}
        </select>
        <div className="modal-footer">
          <button
            data-testid="exportNote"
            type="button"
            className="btn btn-primary"
            onClick={(e) => getLatestNotes(e)}
          >
            Export Note
          </button>
        </div>
        <div
          className="ExportNotes"
          id="ExportNotes"
          style={{ display: "none" }}
        >
          <span className="export-note-title">{currrentNoteTitle}</span>
          {currentNoteContent !== undefined ? (
            <div id={"notes_" + currentNoteId} className="mLeftThirty mTopTen">
              {currentNoteContent}
            </div>
          ) : (
            ""
          )}
        </div>
      </Modal>
      <Modal
        show={isPrintModalOpen}
        onHide={hidePrintModal}
        id="print-content-modal"
        className="modal-dialog1 bk"
        tabIndex="-1"
        role="dialog"
        aria-label="Loading eBook details"
        centered
      >
        <Modal.Body className="print-content-modal">
          <div className="">
            <div className="row">
              <div className="col-lg-7 Page">
                <div className="" id="print-tab-section-container">
                  <div
                    id="print-ereader-scroller"
                    dangerouslySetInnerHTML={{ __html: printContent }}
                  ></div>
                  {noteChecked ? (
                    <div className="outlineDatainPrint">
                      <h2 className="epub-heading cc-section-title">
                        My Notes
                      </h2>
                      <div>
                        {annotationPrintVOList.map((annotation, index) => {
                          if (annotation.annotationVOList) {
                            return (
                              <div key={index}>
                                {annotation.annotationVOList.map(
                                  (note, index1) => {
                                    if (note.noteText) {
                                      if (note.sectionTitle === "-999") {
                                      } else {
                                        return (
                                          <div
                                            key={index1}
                                            className="notesSection"
                                          >
                                            <div className="outline-section-titleB">
                                              {note.sectionTitle}
                                            </div>
                                            <div className="outline-annotation-highlight-B">
                                              {note.noteText}
                                            </div>
                                          </div>
                                        );
                                      }
                                    }
                                  },
                                )}
                              </div>
                            );
                          }
                        })}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-5">
                <button
                  data-testid="close_print_modal"
                  className="closeBtn"
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close Dialog"
                  onClick={() => hidePrintModal()}
                >
                  <span
                    aria-hidden="true"
                    aria-label="Close Dialog"
                    className="modal_button"
                  >
                    &times;
                  </span>
                </button>
                <div className="Heading mb-2 mt-4">Print E-Book Pages</div>
                <div className="divHeight">
                  <div data-testid="printMessage" className="PrintText mb-2">
                    You may print up to{" "}
                    <span>{individualPrintLimit + "%"}</span> of this book.
                  </div>
                  <div data-testid="printStatus" className="PrintText mb-2">
                    <div>Previously Printed: {prevPrint + "%"}</div>
                    <div>Current Selection: {currSelection + "%"} </div>
                    <div>Print Allowance Remaining: {printAllowance + "%"}</div>
                  </div>
                  {printError ? (
                    <div className="printErrorMessage">
                      Your current selection exceeds your print limitation for
                      this title. Please change your selection below.
                    </div>
                  ) : null}
                  <div>
                    <Button
                      className="p-0 pl-3 pr-3 prtPages"
                      bsStyle="primary"
                      bsSize="large"
                      disabled={btnDisabled}
                      onClick={printReadPlugin}
                    >
                      Print Pages
                    </Button>
                  </div>
                  <div className="PrintHeading mt-2 mb-2">Print Options</div>
                  <div>
                    <div
                      data-testid="include_highlights"
                      className="form-group p-0 m-0"
                      tabIndex="0"
                      onKeyDown={(e) => handleHighLightCheckbox(e)}
                    >
                      <input
                        data-testid="input_include_highlights"
                        type="checkbox"
                        id="HighLights"
                        onChange={() => previewPrintHighlights()}
                        defaultChecked={highLightChecked}
                      />
                      <label for="HighLights" className="IncludeText">
                        Include Highlights
                      </label>
                    </div>
                    <div
                      data-testid="include_notes"
                      className="form-group p-0 m-0"
                      tabIndex="0"
                      onKeyPress={(e) => handleChapterCheckbox(e)}
                    >
                      <input
                        data-testid="input_include_notes"
                        type="checkbox"
                        id="IncludeChapter"
                        onChange={() => previewPrintNotes()}
                        defaultChecked={noteChecked}
                      />
                      <label for="IncludeChapter" className="IncludeText">
                        Include My Notes at End of Chapter
                      </label>
                    </div>
                  </div>
                  <div className="PrintHeading mt-2 mb-2">Font Size</div>
                  <div className="container p-0 mb-2 mt-2">
                    <div className="card">
                      <select
                        data-testid="fontSize"
                        className="form-control formfont-size"
                        value={fontSizePrint}
                        onChange={(e) => handleFontSizePrint(e)}
                      >
                        <option value="12">12</option>
                        <option value="14">14</option>
                        <option value="16">16</option>
                        <option value="18">18</option>
                        <option value="20">20</option>
                        <option value="22">22</option>
                        <option value="24">24</option>
                        <option value="28">28</option>
                        <option value="32">32</option>
                      </select>
                    </div>
                  </div>
                  {selectableShow ? (
                    <>
                      <div className="chapterName">{currrentChapterName}</div>
                      <div className="PrintHeading">Select Sections</div>
                      <div className="mt-2">
                        <div
                          data-testid="selectAll"
                          id="selectAll"
                          className="selectText"
                          tabIndex="0"
                          onClick={() => selectAllfunc()}
                          onKeyDown={(e) => handleSelect(e, "selectAll")}
                        >
                          Select All
                        </div>{" "}
                        |{" "}
                        <div
                          data-testid="deselectAll"
                          id="deselectAll"
                          className="selectText"
                          tabIndex="0"
                          onClick={() => deselectAllfunc()}
                          onKeyDown={(e) => handleSelect(e, "deselectAll")}
                        >
                          Deselect All
                        </div>
                      </div>
                      <div id="chapter-section-list">
                        {sectionPrintVOList.map((item, index) => {
                          if (item.sectionTitle === "-999") {
                          } else {
                            if (item.sectionTitle === "IntroductoryText") {
                              return (
                                <div key={index} className="mt-0">
                                  <div
                                    data-testid="introductory_text"
                                    className="form-group p-0 m-0"
                                    tabIndex="0"
                                    onKeyDown={(e) =>
                                      handleSectionCheckbox(
                                        e,
                                        `sectionA${item.sectionId}`,
                                      )
                                    }
                                  >
                                    <input
                                      data-testid="input_introductory_text"
                                      type="checkbox"
                                      id={"sectionA" + item.sectionId}
                                      name={"sectionA" + item.sectionId}
                                      data-id={item.sectionId}
                                      data-type="intro-section"
                                      checked={
                                        !checkedItems[
                                          "sectionA" + item.sectionId
                                        ]
                                      }
                                      onChange={(e) => printPageSection(e)}
                                    />
                                    <label
                                      for={"sectionA" + item.sectionId}
                                      className="IncludeText"
                                    >
                                      Introductory Text
                                    </label>
                                  </div>
                                </div>
                              );
                            } else {
                              return (
                                <div key={index}>
                                  <div className="mt-0">
                                    <div
                                      data-testid="table_of_contents"
                                      className="form-group p-0 m-0"
                                      tabIndex="0"
                                      onKeyDown={(e) =>
                                        handleSectionCheckbox(
                                          e,
                                          `sectionA${item.sectionId}`,
                                        )
                                      }
                                    >
                                      <input
                                        data-testid="input_table_of_contents"
                                        type="checkbox"
                                        className="page-sec"
                                        id={"sectionA" + item.sectionId}
                                        name={"sectionA" + item.sectionId}
                                        data-id={item.sectionId}
                                        data-type={item.sectionType}
                                        checked={
                                          !checkedItems[
                                            "sectionA" + item.sectionId
                                          ]
                                        }
                                        onChange={(e) => printPageSection(e)}
                                        tabIndex="0"
                                      />
                                      <label
                                        for={"sectionA" + item.sectionId}
                                        className="IncludeText"
                                      >
                                        {item.sectionTitle}
                                      </label>
                                    </div>
                                  </div>
                                  {item.childSectionIdVOList
                                    ? item.childSectionIdVOList.map(
                                        (item1, index1) => {
                                          if (item1.sectionTitle === "-999") {
                                          } else {
                                            return (
                                              <div
                                                data-testid="child_section_title"
                                                className="form-group p-0 ml-4 mt-1 mb-1"
                                                tabIndex="0"
                                                onKeyDown={(e) =>
                                                  handleSectionCheckbox(
                                                    e,
                                                    `sectionB${item1.sectionId}`,
                                                  )
                                                }
                                              >
                                                <input
                                                  data-testid="input_child_section_title"
                                                  type="checkbox"
                                                  className="page-sec"
                                                  id={
                                                    "sectionB" + item1.sectionId
                                                  }
                                                  name={
                                                    "sectionB" + item1.sectionId
                                                  }
                                                  data-id={item1.sectionId}
                                                  data-type={item1.sectionType}
                                                  checked={
                                                    !checkedItems[
                                                      "sectionB" +
                                                        item1.sectionId
                                                    ]
                                                  }
                                                  onChange={(e) =>
                                                    printPageSection(e)
                                                  }
                                                  tabIndex="0"
                                                />
                                                <label
                                                  for={
                                                    "sectionB" + item1.sectionId
                                                  }
                                                  className="IncludeText"
                                                >
                                                  {item1.sectionTitle}
                                                </label>
                                              </div>
                                            );
                                          }
                                        },
                                      )
                                    : null}
                                </div>
                              );
                            }
                          }
                        })}
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
export default withRouter(ExportMenu);
